import ReceiptWriteAccess from './ReceiptWriteAccess';
import {loadLookupRecord} from '../../../../utils/effectivePermissions';
import ReceiptBillingFields from './ReceiptBillingFields';
import {billingFields, withSettlementPeriodNote} from './receiptBillingPolicy';
import {hasRole} from '../../../../utils/hasRole';
import React, {useState, useEffect, useRef, useMemo} from 'react';
import {financePermissions} from '../../../../utils/financePermissions';
import {receiptPdfFilename} from '../../../../utils/receiptPdfFilename';
import {useHistory} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";
import {TreeSelect} from "primereact/treeselect";
import {DataTable} from "primereact/datatable";
import {Column} from 'primereact/column';
import {InputSwitch} from "primereact/inputswitch";
import {AutoComplete} from "primereact/autocomplete";
import {Calendar} from "primereact/calendar";
import {addLocale} from 'primereact/api';
import {FileUpload} from 'primereact/fileupload';
import moment from "moment";
import {InputNumber} from "primereact/inputnumber";
import {Sidebar} from "primereact/sidebar";
import {Message} from "primereact/message";
import {InputMask} from "primereact/inputmask";
import download from "js-file-download";
import { ProgressBar } from 'primereact/progressbar';
import {Slider} from "primereact/slider";
import {InputTextarea} from 'primereact/inputtextarea';
import axios from "axios";

import PartnerFormComponent from "../../../2.1/partner/PartnerFormComponent";
import ReceiptFileUploadService from "../../../2.0/_services/receipt/ReceiptFileUploadService";
import ReceiptDownloadPdfService from "../../../2.0/_services/receipt/ReceiptDownloadPdfService";
import ReceiptPdfViewerComponent from './ReceiptPdfViewerComponent';
import ReceiptUnavailable, {closeReceipt} from './ReceiptUnavailable';

const collectExpandedTreeKeys = (nodes, expandedKeys = {}) => {
  (nodes || []).forEach((node) => {
    if (Array.isArray(node?.children) && node.children.length > 0) {
      expandedKeys[String(node.key)] = true;
      collectExpandedTreeKeys(node.children, expandedKeys);
    }
  });

  return expandedKeys;
};

const ReceiptFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  if (!window.App.state) window.App.state = {};
  if (!window.App.state.props) window.App.state.props = {};
  const [formData, setFormData] = useState({});
  const periodNoteState = useRef({generated: null, edited: false});
  const [unavailable, setUnavailable] = useState(false);
  const [loading, setLoading] = useState(false);
  const submitActionRef = useRef('save');
  const [partnerLoading, setPartnerLoading] = useState(false);
  const [paymentMethodIsPaid, setPaymentMethodIsPaid] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [receiptgroups, setReceiptgroups] = useState([]);
  const [vats, setVats] = useState([]);
  const [selectedLocalFile, setSelectedLocalFile] = useState(null);
  const [units, setUnits] = useState([]);
  const [partnerAddresses, setPartnerAddresses] = useState([]);
  const [shippingAddress, setShippingAddress] = useState({});
  const [bankAccounts, setBankAccounts] = useState([]);
  const [partnerDisplayValue, setPartnerDisplayValue] = useState('');
  const [selectedPartnerData, setSelectedPartnerData] = useState(null);

  const [costAllocationSummary, setCostAllocationSummary] = useState([]);
  const [costAllocationDialog, setCostAllocationDialog] = useState(false);
  const [costAllocationCosttypes, setCostAllocationCosttypes] = useState([]);
  const [costAllocationCostcenters, setCostAllocationCostcenters] = useState([]);
  const [costAllocationExpandedKeys, setCostAllocationExpandedKeys] = useState({});
  const [costAllocationCosttypeId, setCostAllocationCosttypeId] = useState(null);
  const [costAllocationCostcenterId, setCostAllocationCostcenterId] = useState(null);
  const [costAllocationLoading, setCostAllocationLoading] = useState(false);
  const [costAllocationFormDialog, setCostAllocationFormDialog] = useState(false);
  const [costAllocationFormLoading, setCostAllocationFormLoading] = useState(false);
  const [costAllocationFormError, setCostAllocationFormError] = useState(null);
  const [costAllocationFormMethod, setCostAllocationFormMethod] = useState('create');
  const [costAllocationEditId, setCostAllocationEditId] = useState(null);
  const [costAllocationFormCosttypeId, setCostAllocationFormCosttypeId] = useState(null);
  const [costAllocationFormCostcenterId, setCostAllocationFormCostcenterId] = useState(null);
  const [costAllocationFormAmount, setCostAllocationFormAmount] = useState(null);
  const [costAllocationSliderPercent, setCostAllocationSliderPercent] = useState(0);

  const [revenueAllocationSummary, setRevenueAllocationSummary] = useState([]);
  const [revenueAllocationDialog, setRevenueAllocationDialog] = useState(false);
  const [revenueAllocationProfitcenters, setRevenueAllocationProfitcenters] = useState([]);
  const [revenueAllocationProfitcenterId, setRevenueAllocationProfitcenterId] = useState(null);
  const [revenueAllocationLoading, setRevenueAllocationLoading] = useState(false);

  useEffect(() => {
    setCostAllocationExpandedKeys(collectExpandedTreeKeys(costAllocationCostcenters));
  }, [costAllocationCostcenters]);

  const [revenueAllocationFormDialog, setRevenueAllocationFormDialog] = useState(false);
  const [revenueAllocationFormLoading, setRevenueAllocationFormLoading] = useState(false);
  const [revenueAllocationFormError, setRevenueAllocationFormError] = useState(null);
  const [revenueAllocationFormMethod, setRevenueAllocationFormMethod] = useState('create');
  const [revenueAllocationEditId, setRevenueAllocationEditId] = useState(null);
  const [revenueAllocationFormProfitcenterId, setRevenueAllocationFormProfitcenterId] = useState(null);
  const [revenueAllocationFormAmount, setRevenueAllocationFormAmount] = useState(null);
  const [revenueAllocationSliderPercent, setRevenueAllocationSliderPercent] = useState(0);

  const [revenueItemDialog, setRevenueItemDialog] = useState(false);
  const [revenueItemDialogLoading, setRevenueItemDialogLoading] = useState(false);
  const [revenueItemDialogItems, setRevenueItemDialogItems] = useState([]);
  const [revenueItemDialogReceiptItem, setRevenueItemDialogReceiptItem] = useState(null);
  const [selectedRevenueItem, setSelectedRevenueItem] = useState(null);

  const [costItemDialog, setCostItemDialog] = useState(false);
  const [costItemDialogLoading, setCostItemDialogLoading] = useState(false);
  const [costItemDialogItems, setCostItemDialogItems] = useState([]);
  const [costItemDialogReceiptItem, setCostItemDialogReceiptItem] = useState(null);

  const [selectedCostItem, setSelectedCostItem] = useState(null);

  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileUploading, setFileUploading] = useState(false);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [fileUploadError, setFileUploadError] = useState(null);
  const [fileBlobUrl, setFileBlobUrl] = useState(null);
  const fileUploadRef = useRef(null);

  const [fileBusy, setFileBusy] = useState(false);
  const hasSavedItems = Array.isArray(formData?.items) && formData.items.some(i => i?.id);

  const DAY_RANGE = 180;
  const calendarMinDate = useMemo(() => moment().startOf('day').subtract(DAY_RANGE, 'days').toDate(), []);
  const calendarMaxDate = useMemo(() => moment().startOf('day').add(DAY_RANGE, 'days').toDate(), []);

  const [previewDownloading, setPreviewDownloading] = useState(false);

  const [costAllocationFieldErrors, setCostAllocationFieldErrors] = useState({});

  const [totVat, setTotVat] = useState({
    percent: 27,
    name: '27%',
    id: 10
  });
  const [file, setFile] = useState(false);
  const [serverErrors, setServerErrors] = useState({});

  const revokeFileUrl = (url) => {
    try { if (url) URL.revokeObjectURL(url); } catch {}
  };


  const isCostPosted = (() => {
    if (typeof formData.cost_posted === 'boolean') return formData.cost_posted;
    return false;
  })();

  const isRevenuePosted = (() => {
    if (typeof formData.revenue_posted === 'boolean') return formData.revenue_posted;
    return false;
  })();

  const fetchRevenueAllocationSummary = (receiptId) => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/revenue-allocation/summary/receipt/" + receiptId,
      headers: headers
    });
  };

  const fetchRevenueItemsByReceiptItem = (receiptItemId) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/revenue-item?search[receipt_item][operator]==&search[receipt_item][value]=" + Number(receiptItemId),
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const submitRevenueItemBatch = (receiptId) => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API_HOST + "/api/v2/revenue-item/batch/receipt/" + receiptId,
      headers: headers
    });
  };

  const runRevenueItemBatchPerItem = () => {
    if (!formData?.id) return;
    setRevenueAllocationLoading(true);
    submitRevenueItemBatch(formData.id)
      .then(() => {
        window.App.toastShow('success', t('toastSaveSuccess'), t('revenueAllocation') + ' tételenként elkészült.');
        const headers = {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        };
        return axios({
          method: 'get',
          url: process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + formData.id,
          headers: headers
        });
      })
      .then(res => {
        const d = res.data?.data || res.data;
        setFormData(prev => ({
          ...prev,
          ...d,
          revenue_posted: true
        }));
        setRevenueAllocationLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba', error.response?.data?.detail || error.toString(), '', error.response);
        setRevenueAllocationLoading(false);
      });
  };

  const fetchProfitCenterListSimple = () => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/profit-center?first=0&rows=9999&page=1",
      headers: headers
    });
  };

  const createRevenueAllocation = (revenueItemId, projectId, amount, currency) => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API_HOST + "/api/v2/revenue-allocation",
      data: {
        project: Number(projectId),
        revenue_item: Number(revenueItemId),
        amount: Number(amount || 0),
        currency: currency || formData.currency || 'HUF'
      },
      headers: headers
    });
  };

  const fetchRevenueItemsByReceipt = (receiptId) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/revenue-item?search[receipt][operator]==&search[receipt][value]=" + Number(receiptId) + "&rows=9999",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const isEmptyPaymentDate = (value) => {
    return value === null || value === undefined || value === '';
  };

  const getCurrentReceiptType = () => {
    return resolveReceiptType({
      outgoing: outgoing,
      receiptType:
        window.App.state.props?.receipt_type ||
        formData.receipt_type ||
        ''
    });
  };

  const getPartnerPaymentDueDate = (partner) => {
    const paymentDueDays = Number(
      partner?.payment_due_days ??
      partner?.paymentDueDays ??
      0
    );
    if (!Number.isFinite(paymentDueDays) || paymentDueDays <= 0) {
      return null;
    }
    return moment().startOf('day').add(paymentDueDays, 'days').format('YYYY-MM-DD');
  };

  const shouldSetPaymentDateFromPartner = (partner) => {
    return (
      getCurrentReceiptType() === 'CUSTOMER_INVOICE' &&
      isEmptyPaymentDate(formData.payment_date) &&
      getPartnerPaymentDueDate(partner)
    );
  };

  const calculatePartnerPaymentDate = (partner, customIssueDate = null) => {
    const paymentDueDays = Number(partner?.payment_due_days ?? partner?.paymentDueDays ?? 0);
    if (!Number.isFinite(paymentDueDays) || paymentDueDays <= 0) {
      return null;
    }
    const receiptType = getCurrentReceiptType();
    if (receiptType === 'CUSTOMER_INVOICE') {
      return moment().startOf('day').add(paymentDueDays, 'days').format('YYYY-MM-DD');
    } 
    if (receiptType === 'SUPPLIER_INVOICE') {
      const issueDate = customIssueDate || formData.issue_date;
      if (!issueDate) return null;
      return moment(issueDate).startOf('day').add(paymentDueDays, 'days').format('YYYY-MM-DD');
    }
    return null;
  };

  const shouldCalculatePaymentDate = (partner, currentPaymentDate, customIssueDate = null) => {
    if (!partner || !isEmptyPaymentDate(currentPaymentDate)) return false;
    const receiptType = getCurrentReceiptType();
    if (receiptType === 'CUSTOMER_INVOICE') return true;
    if (receiptType === 'SUPPLIER_INVOICE' && (customIssueDate || formData.issue_date)) return true;
    return false;
  };

  const formatCurrency = (currency, amount) => {
    if (window.App && typeof window.App.currencyFormatter === 'function') {
      return window.App.currencyFormatter(currency || formData.currency, Number(amount || 0));
    }
    return <>{Number(amount || 0)}&nbsp;{currency || formData.currency}</>
  };

  const resolveOutgoing = (...candidates) => {
    for (const v of candidates) {
      if (typeof v === 'boolean') return v;
    }
    return true;
  };

  const outgoing = resolveOutgoing(
    formData?.outgoing,
    window.App.state.props?.outgoing,
    props?.initialValues?.outgoing,
  );

  const resolveExternal = (...candidates) => {
    for (const v of candidates) if (typeof v === 'boolean') return v;
    return false;
  };

  const external = resolveExternal(
    formData?.external,
    window.App.state.props?.external,
    props?.initialValues?.external
  );

  const receiptGroupName =
    formData?.receipt_group?.name ||
    formData?.receiptGroup?.name ||
    window.App.state.props?.receiptGroupName ||
    window.App.state.props?.name ||
    '';
  const receiptFormOperation = formData?.id ? t('updateSuffix') : t('createSuffix');
  const receiptFormTitle = receiptGroupName
    ? `${receiptGroupName} • ${receiptFormOperation}`
    : (formData?.id ? t('receiptUpdate') : t('receiptCreate'));

  const resolveReceiptType = ({ outgoing, receiptType }) => {
    if (typeof receiptType === 'string' && /^(CUSTOMER|SUPPLIER)_/.test(receiptType)) {
      return receiptType;
    }
    switch (receiptType) {
      case 'invoice':
        return outgoing ? 'CUSTOMER_INVOICE' : 'SUPPLIER_INVOICE';
      case 'fee_request':
        return outgoing ? 'CUSTOMER_PROFORMA' : 'SUPPLIER_PROFORMA';
      case 'advance_invoice':
      case 'advance':
        return outgoing ? 'CUSTOMER_ADVANCE_INVOICE' : 'SUPPLIER_ADVANCE_INVOICE';
      default:
        return outgoing ? 'CUSTOMER_INVOICE' : 'SUPPLIER_INVOICE';
    }
  };

  const isSupplierReceipt = (() => {
    const rt = (window.App.state.props?.receipt_type || formData.receipt_type || formData.receipt_type || '');
    return typeof rt === 'string' && rt.startsWith('SUPPLIER_');
  })();

  const isCustomerReceipt = (() => {
    const rt = resolveReceiptType({
      outgoing: outgoing,
      receiptType: window.App.state.props?.receiptType || formData.receipt_type || ''
    });
    return typeof rt === 'string' && rt.startsWith('CUSTOMER_');
  })();

  const submitCostItemBatch = (receiptId) => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API_HOST + "/api/v2/cost-item/batch/receipt/" + receiptId,
      headers: headers
    });
  };

  const fetchCompanyListSimple = () => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/company?first=0&rows=9999&page=1",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const fetchPaymentMethodListSimple = () => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/payment-method?first=0&rows=9999&page=1",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const fetchCostItemsByReceiptItem = (receiptItemId) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/cost-item?search[receipt_item][operator]==&search[receipt_item][value]=" + Number(receiptItemId),
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const toNumberSafe = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const getId = (val) => {
    if (val === null || val === undefined) return null;
    if (Array.isArray(val)) return null;
    if (typeof val === 'object') {
      if (val.id !== undefined && val.id !== null && String(val.id).trim() !== '') {
        return Number(val.id);
      }
      return null;
    }
    if (typeof val === 'string' && val.trim() === '') return null;

    const num = Number(val);
    return Number.isFinite(num) ? num : null;
  };

  const calcAmountFromPercent = (baseAmount, percent) => {
    const base = toNumberSafe(baseAmount);
    const p = toNumberSafe(percent);
    return (base * p) / 100;
  };

  const calcPercentFromAmount = (baseAmount, amount) => {
    const base = toNumberSafe(baseAmount);
    const a = toNumberSafe(amount);
    if (!base) return 0;
    return Math.max(0, Math.min(100, (a / base) * 100));
  };

  const finalizeReceipt = (receiptId, data) => {
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + receiptId + "/finalize",
      data: data,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const refreshRevenueItemDialogData = () => {
    if (!revenueItemDialogReceiptItem?.id) return;
    setRevenueItemDialogLoading(true);
    fetchRevenueItemsByReceiptItem(revenueItemDialogReceiptItem.id)
      .then(res => {
        const payload = res.data?.data || res.data;
        const items = payload?.items || [];
        const normalized = Array.isArray(items) ? items : [];
        setRevenueItemDialogItems(normalized);
        if (selectedRevenueItem?.id) {
          const same = normalized.find(x => x.id === selectedRevenueItem.id);
          setSelectedRevenueItem(same || normalized[0] || null);
        } else {
          setSelectedRevenueItem(normalized[0] || null);
        }
        setRevenueItemDialogLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setRevenueItemDialogLoading(false);
      });
  };

  const refreshMainRevenueSummary = () => {
    if (!formData?.id) return;
    fetchRevenueAllocationSummary(formData.id)
      .then(res => {
        const data = res.data?.data || [];
        setRevenueAllocationSummary(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
  };

  const openRevenueItemDialog = (receiptItemRow) => {
    if (!receiptItemRow?.id) return;
    setRevenueItemDialogReceiptItem(receiptItemRow);
    setRevenueItemDialog(true);
    setRevenueItemDialogLoading(true);
    fetchRevenueItemsByReceiptItem(receiptItemRow.id)
      .then(res => {
        const payload = res.data?.data || res.data;
        const items = payload?.items || [];
        const normalized = Array.isArray(items) ? items : [];

        setRevenueItemDialogItems(normalized);
        setSelectedRevenueItem(normalized[0] || null);
        setRevenueItemDialogLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setRevenueItemDialogLoading(false);
      });
  };

  const refreshCostItemDialogData = () => {
    if (!costItemDialogReceiptItem?.id) return;
    setCostItemDialogLoading(true);
    fetchCostItemsByReceiptItem(costItemDialogReceiptItem.id)
      .then(res => {
        const payload = res.data?.data || res.data;
        const items = payload?.items || [];
        const normalized = Array.isArray(items) ? items : [];
        setCostItemDialogItems(normalized);
        if (selectedCostItem?.id) {
          const same = normalized.find(x => x.id === selectedCostItem.id);
          setSelectedCostItem(same || normalized[0] || null);
        } else {
          setSelectedCostItem(normalized[0] || null);
        }
        setCostItemDialogLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setCostItemDialogLoading(false);
      });
  };

  const refreshMainCostSummary = () => {
    if (!formData?.id) return;
    fetchCostAllocationSummary(formData.id)
      .then(res => {
        const data = res.data?.data || [];
        setCostAllocationSummary(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
  };

  const openCreateCostAllocationForm = () => {
    if (!selectedCostItem?.id) return;

    setCostAllocationFormError(null);
    setCostAllocationFormMethod('create');
    setCostAllocationEditId(null);

    setCostAllocationFormCosttypeId(null);
    setCostAllocationFormCostcenterId(null);

    const base = toNumberSafe(selectedCostItem?.amount);
    const initialPercent = base > 0 ? 100 : 0;

    setCostAllocationSliderPercent(initialPercent);
    setCostAllocationFormAmount(base);

    setCostAllocationFormLoading(true);
    Promise.all([fetchCostTypeListSimple(), fetchCostCenterListSimple()])
      .then(([ctRes, ccRes]) => {
        const ctData = ctRes.data?.data;
        const ccData = ccRes.data?.data;

        const ctItems = Array.isArray(ctData) ? ctData : (ctData?.items || []);
        const ccItems = Array.isArray(ccData) ? ccData : (ccData?.items || []);

        setCostAllocationCosttypes(ctItems);
        setCostAllocationCostcenters(ccItems);

        setCostAllocationFormDialog(true);
        setCostAllocationFormLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setCostAllocationFormLoading(false);
      });
  };

  const openEditCostAllocationForm = (allocationRow) => {
    if (!selectedCostItem?.id || !allocationRow?.id) return;

    setCostAllocationFormError(null);
    setCostAllocationFormMethod('update');
    setCostAllocationEditId(allocationRow.id);

    const ctId = allocationRow?.cost_type?.id ?? allocationRow?.cost_type ?? null;
    const ccId = allocationRow?.cost_center?.id ?? allocationRow?.cost_center ?? null;
    const amount = toNumberSafe(allocationRow?.amount);

    setCostAllocationFormCosttypeId(ctId ? Number(ctId) : null);
    setCostAllocationFormCostcenterId(ccId ? Number(ccId) : null);
    setCostAllocationFormAmount(amount);

    const base = selectedCostItem?.amount;
    setCostAllocationSliderPercent(calcPercentFromAmount(base, amount));

    setCostAllocationFormLoading(true);
    Promise.all([fetchCostTypeListSimple(), fetchCostCenterListSimple()])
      .then(([ctRes, ccRes]) => {
        const ctData = ctRes.data?.data;
        const ccData = ccRes.data?.data;

        const ctItems = Array.isArray(ctData) ? ctData : (ctData?.items || []);
        const ccItems = Array.isArray(ccData) ? ccData : (ccData?.items || []);

        setCostAllocationCosttypes(ctItems);
        setCostAllocationCostcenters(ccItems);

        setCostAllocationFormDialog(true);
        setCostAllocationFormLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setCostAllocationFormLoading(false);
      });
  };

  const submitCostAllocationForm = () => {
    if (!selectedCostItem?.id) return;
    setCostAllocationFormError(null);
    setCostAllocationFieldErrors({});
    const n = Number.parseFloat(toNumberSafe(costAllocationFormAmount));
    const amountFloat = Number.isFinite(n) ? (Number.isInteger(n) ? n + 0.000001 : n) : 0;
    const payload = {
      cost_type: costAllocationFormCosttypeId ? Number(costAllocationFormCosttypeId) : null,
      cost_center: costAllocationFormCostcenterId ? Number(costAllocationFormCostcenterId) : null,
      cost_item: Number(selectedCostItem.id),
      amount: amountFloat,
    };
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    setCostAllocationFormLoading(true);
    const req = costAllocationFormMethod === 'update'
      ? axios.patch(process.env.REACT_APP_API_HOST + "/api/v2/cost-allocation/" + Number(costAllocationEditId), payload, { headers })
      : axios.post(process.env.REACT_APP_API_HOST + "/api/v2/cost-allocation", payload, { headers });
    req
      .then(() => {
        window.App.toastShow('success', 'Sikeres mentés!');
        setCostAllocationFormDialog(false);
        setCostAllocationFormLoading(false);
        setCostAllocationFieldErrors({});
        refreshCostItemDialogData();
        refreshMainCostSummary();
      })
      .catch(error => {
        const fieldErrors = error.response?.data?.data;
        if (fieldErrors && typeof fieldErrors === 'object') {
          setCostAllocationFieldErrors(fieldErrors);
          setCostAllocationFormError(error.response?.data?.message || null);
        } else {
          const detail = error.response?.data?.detail || error.response?.data?.message || error.toString();
          setCostAllocationFormError(detail);
        }
        setCostAllocationFormLoading(false);
      });
  };

  const openCreateRevenueAllocationForm = () => {
    if (!selectedRevenueItem?.id) return;

    setRevenueAllocationFormError(null);
    setRevenueAllocationFormMethod('create');
    setRevenueAllocationEditId(null);
    setRevenueAllocationFormProfitcenterId(null);

    const base = toNumberSafe(selectedRevenueItem?.amount);
    const initialPercent = base > 0 ? 100 : 0;

    setRevenueAllocationSliderPercent(initialPercent);
    setRevenueAllocationFormAmount(base);

    setRevenueAllocationFormLoading(true);

    fetchProfitCenterListSimple()
      .then((pcRes) => {
        const pcData = pcRes.data?.data;
        const pcItems = Array.isArray(pcData) ? pcData : (pcData?.items || []);

        setRevenueAllocationProfitcenters(pcItems);
        setRevenueAllocationFormDialog(true);
        setRevenueAllocationFormLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setRevenueAllocationFormLoading(false);
      });
  };

  const openEditRevenueAllocationForm = (allocationRow) => {
    if (!selectedRevenueItem?.id || !allocationRow?.id) return;

    setRevenueAllocationFormError(null);
    setRevenueAllocationFormMethod('update');
    setRevenueAllocationEditId(allocationRow.id);

    const pcId = allocationRow?.profit_center?.id ?? allocationRow?.profit_center ?? null;
    const amount = toNumberSafe(allocationRow?.amount);

    setRevenueAllocationFormProfitcenterId(pcId ? Number(pcId) : null);
    setRevenueAllocationFormAmount(amount);
    setRevenueAllocationSliderPercent(calcPercentFromAmount(selectedRevenueItem?.amount, amount));

    setRevenueAllocationFormLoading(true);

    fetchProfitCenterListSimple()
      .then((pcRes) => {
        const pcData = pcRes.data?.data;
        const pcItems = Array.isArray(pcData) ? pcData : (pcData?.items || []);

        setRevenueAllocationProfitcenters(pcItems);
        setRevenueAllocationFormDialog(true);
        setRevenueAllocationFormLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setRevenueAllocationFormLoading(false);
      });
  };

  const submitRevenueAllocationForm = () => {
    if (!selectedRevenueItem?.id) return;

    setRevenueAllocationFormError(null);

    const n = Number.parseFloat(toNumberSafe(revenueAllocationFormAmount));
    const amountFloat = Number.isFinite(n) ? (Number.isInteger(n) ? n + 0.000001 : n) : 0;

    const payload = {
      project: revenueAllocationFormProfitcenterId ? Number(revenueAllocationFormProfitcenterId) : null,
      revenue_item: Number(selectedRevenueItem.id),
      amount: amountFloat,
      currency: selectedRevenueItem?.currency || formData.currency || 'HUF',
    };

    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };

    setRevenueAllocationFormLoading(true);

    const req = revenueAllocationFormMethod === 'update'
      ? axios.patch(process.env.REACT_APP_API_HOST + "/api/v2/revenue-allocation/" + Number(revenueAllocationEditId), payload, { headers })
      : axios.post(process.env.REACT_APP_API_HOST + "/api/v2/revenue-allocation", payload, { headers });

    req
      .then(() => {
        window.App.toastShow('success', 'Sikeres mentés!');
        setRevenueAllocationFormDialog(false);
        setRevenueAllocationFormLoading(false);
        refreshRevenueItemDialogData();
        refreshMainRevenueSummary();
      })
      .catch(error => {
        const detail = error.response?.data?.detail || error.response?.data?.message || error.toString();
        setRevenueAllocationFormError(detail);
        setRevenueAllocationFormLoading(false);
      });
  };

  const openCostItemDialog = (receiptItemRow) => {
    if (!receiptItemRow?.id) return;
    setCostItemDialogReceiptItem(receiptItemRow);
    setCostItemDialog(true);
    setCostItemDialogLoading(true);
    fetchCostItemsByReceiptItem(receiptItemRow.id)
      .then(res => {
        const payload = res.data?.data || res.data;
        const items = payload?.items || [];
        setCostItemDialogItems(Array.isArray(items) ? items : []);
        const normalized = Array.isArray(items) ? items : [];
        setCostItemDialogItems(normalized);
        setSelectedCostItem(normalized[0] || null);
        setCostItemDialogLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setCostItemDialogLoading(false);
      });
  };

  const fetchCostAllocationSummary = (receiptId) => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/cost-allocation/summary/receipt/" + receiptId,
      headers: headers
    });
  };

  const patchReceiptFile = (receiptGroupId, receiptId, fileIdOrNull) => {
    const headers = {
      Authorization: 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId"),
    };
    const url = `${process.env.REACT_APP_API_HOST}/api/v2/receipt/${Number(receiptGroupId)}/${Number(receiptId)}`;
    return axios.patch(url, { file: fileIdOrNull }, { headers });
  };

  const fetchCostTypeListSimple = () => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/cost-type?first=0&rows=9999&page=1",
      headers: headers
    });
  };

  const fetchCostCenterListSimple = () => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/cost-center/tree",
      headers: headers
    });
  };

  const submitCostAllocationBatch = (receiptId, costTypeId, costCenterId) => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API_HOST + "/api/v2/cost-allocation/batch/receipt/" + receiptId,
      data: {
        cost_type: Number(costTypeId),
        cost_center: Number(costCenterId)
      },
      headers: headers
    });
  };

  const runCostItemBatchPerItem = () => {
    if (!formData?.id) return;
    setCostAllocationLoading(true);
    submitCostItemBatch(formData.id)
      .then(() => {
        window.App.toastShow('success', t('toastSaveSuccess'), t('costAllocation') + ' tételenként elkészült.');
        const headers = {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        };
        return axios({
          method: 'get',
          url: process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + formData.id,
          headers: headers
        });
      })
      .then(res => {
        const d = res.data?.data || res.data;
        setFormData(prev => ({ ...prev, ...d }));
        if (d?.cost_posted === true && isSupplierReceipt === true) {
          fetchCostAllocationSummary(d.id)
            .then(r2 => {
              const s = r2.data?.data || [];
              setCostAllocationSummary(Array.isArray(s) ? s : []);
            })
            .catch(() => {});
        }
        setCostAllocationLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba', error.response?.data?.detail || error.toString());
        setCostAllocationLoading(false);
      });
  };

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const uiOutgoing = outgoing;
  const uiExternal = external;
  // const uiReceiptType = window.App.state.props?.receiptType || formData.receiptType || formData.receipt_type; 

  const serverFieldMap = {
    issue_date: 'issue_date',
    delivery_date: 'delivery_date',
    payment_date: 'payment_date',
    receipt_number: 'receipt_number',
    payment_method: 'payment_method',
    partner: 'partner',
  };

  const mapBackend400ToFormErrors = (error) => {
    if (error?.response?.status !== 400) return null;
    const fieldErrors = error?.response?.data?.data;
    if (!fieldErrors || typeof fieldErrors !== 'object') return null;
    const out = {};
    Object.keys(fieldErrors).forEach((key) => {
      const mappedKey = serverFieldMap[key] || key;
      const v = fieldErrors[key];
      out[mappedKey] = Array.isArray(v) ? (v[0]) : (v);
    });
    return out;
  };

  const showReceiptNumber = uiExternal;
  const onSubmit = async (data, form) => {
    const submitAction = submitActionRef.current;
    const shouldFinalizeAfterSave = submitAction === 'save-and-finalize' || submitAction === 'save-and-close';
    submitActionRef.current = 'save';
    let savedBeforeFinalize = false;
    setLoading(true);

    try {
      const merged = { ...formData, ...data };

      const getId = (val) => {
        if (val === null || val === undefined) return null;
        if (Array.isArray(val)) return null;

        if (typeof val === 'object') {
          if (val.id !== undefined && val.id !== null && String(val.id).trim() !== '') return Number(val.id);
          return null;
        }

        if (typeof val === 'string' && val.trim() === '') return null;

        const num = Number(val);
        return Number.isFinite(num) ? num : null;
      };

      const formatDate = (dateStr) => (dateStr ? moment(dateStr).format('YYYY-MM-DD') : null);

      const items = merged.items || formData.items || [];
      if (!items || !items[0]) {
        setLoading(false);
        window.App.toastShow('warn', 'Hiányzó adat', 'Legalább egy tételt szükséges rögzíteni a bizonylaton!');
        return { _error: 'Legalább egy tételt szükséges rögzíteni a bizonylaton!' };
      }

      const isOutgoing = outgoing;
      const isExternal = resolveExternal(
        merged?.external,
        window.App.state.props?.external,
        props?.initialValues?.external
      );

      const payload = {
        company: getId(data.company) || getId(formData.company) || Number(localStorage.getItem('defaultCompanyId')) || 1,
        partner: getId(data.partner) || getId(formData.partner),
        delivery_date: formatDate(merged.delivery_date || merged.delivery_date),
        payment_date: formatDate(merged.payment_date || merged.payment_date),
        company_bank_account: getId(data.companyBankAccount) || getId(formData.companyBankAccount) || getId(formData.company_bank_account),
        currency: merged.currency || 'HUF',
        ...billingFields(formData),
        exchange_rate: formData.exchange_rate ?? formData.exchangeRate ?? null,
        payment_method:
          getId(data.payment_method) ||
          getId(data.payment_method) ||
          getId(formData.payment_method) ||
          getId(formData.payment_method) ||
          Number(localStorage.getItem('defaultPaymentMethodId')) ||
          2,
        locale: (merged.language || merged.locale || 'hu').toLowerCase(),
        note: formData.note ?? "",
        file: (uploadedFile?.id ?? formData?.file?.id ?? formData?.file) || null,
        external: isExternal,
        outgoing: isOutgoing,
        items: items
      };
      const receiptTypeUi = window.App.state.props?.receiptType;
      payload.receipt_type = resolveReceiptType({
        outgoing: isOutgoing,
        receiptType: receiptTypeUi
      });
      if (isExternal) {
        payload.issue_date = formatDate(merged.issue_date || merged.issue_date);
        const userReceiptNumber = merged.receipt_number || merged.receipt_number;
        if (userReceiptNumber) {
          payload.receipt_number = String(userReceiptNumber);
        }
      }
      const headers = {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      };
      const apiHost = process.env.REACT_APP_API_HOST;
      const rgId = getSafeReceiptGroupId(merged);
      const receiptId = formData.id;
      if ((props && props.initialValues) || formData.id) {
        if (!receiptId) {
          setLoading(false);
          window.App.toastShow('error', 'Hiba', 'Hiányzó bizonylat azonosító!');
          return;
        }
        const url = `${apiHost}/api/v2/receipt/${rgId}/${receiptId}`;
        // await axios({ method: 'put', url, data: payload, headers });
        const savedResponse = await axios({ method: 'patch', url, data: payload, headers });
        const savedReceipt = savedResponse.data?.data || savedResponse.data;
        if (savedReceipt?.exchange_rate !== undefined) {
          setFormData(prev => ({...prev, exchange_rate: savedReceipt.exchange_rate, exchangeRate: savedReceipt.exchange_rate,
            exchange_rate_date: savedReceipt.exchange_rate_date, exchange_rate_source: savedReceipt.exchange_rate_source}));
        }
        savedBeforeFinalize = true;
        if (file !== false) ReceiptFileUploadService(file, formData.id).catch(console.error);

        if (shouldFinalizeAfterSave) {
          const finalizeResponse = await finalizeReceipt(receiptId, {expected_exchange_rate: formData.currency === 'HUF' ? 1 : (formData.exchange_rate ?? formData.exchangeRate ?? null)});
          const isCloseAction = submitAction === 'save-and-close';
          window.App.toastShow(
            'success',
            isCloseAction ? 'Sikeres mentés és bizonylat lezárás!' : 'Sikeres mentés és bizonylat kiállítás!'
          );
          const nextAppState = {
              rerenderReceiptList: true,
              sidebarReceiptUpdate: false,
              sidebarReceiptShow: false,
              sidebarReceiptInvoiceCreate: false,
              sidebarReceiptFeeRequestCreate: false,
              sidebarReceiptDeliveryNoteCreate: false,
              newPartnerId: null,
              newPartnerName: null,
              props: finalizeResponse.data.data,
          };
          if (!isCloseAction) {
            nextAppState.dialogReceiptSend = true;
          }
          const previousLocation = history.location.pathname + history.location.search;
          window.App.setState(nextAppState, () => {
            history.push('/finance/receipt/read/' + receiptId, {
              from: previousLocation,
            });
          });
        } else {
          window.App.toastShow('success', 'Sikeres módosítás!');
          window.App.setState({ rerenderReceiptList: true, sidebarReceiptUpdate: false });
        }
      } else {
        const url = `${apiHost}/api/v2/receipt/${rgId}`;
        const response = await axios({ method: 'post', url, data: payload, headers });
        const newReceipt = response.data?.data || response.data;
        if (file !== false) ReceiptFileUploadService(file, newReceipt.id).catch(console.error);
        window.App.toastShow('success', 'Sikeres mentés!');
        setFormData({ ...newReceipt, receiptgroupId: rgId });
        setItemDialog(true);
        setItemFormMethod('create');
        window.App.setState({
          rerenderReceiptList: true,
          sidebarReceiptInvoiceCreate: false,
          sidebarReceiptCostCreate: false,
          sidebarReceiptFeeRequestCreate: false,
          sidebarReceiptDeliveryNoteCreate: false
        });
      }
    } catch (error) {
      if (shouldFinalizeAfterSave && savedBeforeFinalize) {
        const finalizeActionLabel = submitAction === 'save-and-close' ? 'lezárása' : 'kiállítása';
        window.App.setState({ rerenderReceiptList: true });
        window.App.toastShow(
          'error',
          `A mentés sikerült, de a bizonylat ${finalizeActionLabel} sikertelen.`,
          error.response?.data?.detail || error.response?.data?.message || error.toString(),
          '',
          error.response
        );
        return { _error: `A mentés sikerült, de a bizonylat ${finalizeActionLabel} sikertelen.` };
      }

      const mapped = mapBackend400ToFormErrors(error);
      if (mapped) {
        console.error('400 VALIDATION ERROR:', error.response);
        return mapped;
      }
      window.App.toastShow('error', 'Hiba', error.response?.data?.detail || error.response?.data?.message || error.toString(), '', error.response);
      return { _error: 'Hiba történt a mentés során.' };
    } finally {
      setLoading(false);
    }
  };

  const isFormFieldValid = (meta, submitFailed, name) => {
    return !!((meta.touched || submitFailed) && (meta.error || meta.submitError));
  };

  const getFormErrorMessage = (meta, submitFailed, name) => {
    const msg = meta.error || meta.submitError || serverErrors[name];
    return isFormFieldValid(meta, submitFailed, name) && <small className="p-error">{msg}</small>;
  };

  // items
  const itemValidate = (data) => {
    let errors = {};
    return errors;
  };
  const itemVatBody = (rowData) => {
    if (rowData.vat_rate && rowData.vat_rate.label) {
      return <>{rowData.vat_rate.label}</>;
    }
    if (vats && vats.length > 0) {
      const vatId = rowData.vat_rate?.id || rowData.vat;
      const foundVat = vats.find(v => v.id === vatId);
      if (foundVat) {
        return <>{foundVat.label || foundVat.acronym}</>;
      }
    }
    return null;
};
  // const unitPriceBody = (rowData) => {
  //   return formatCurrency(formData.currency, rowData.unitPrice);
  // }
  // const getReceiptGroupId = () => {
  //   const fromFormData =
  //     formData?.receiptgroupId ||
  //     formData?.receiptGroupId ||
  //     (formData?.receipt_group && (formData.receipt_group.id || formData.receipt_group)) ||
  //     formData?.receipt_group_id ||
  //     formData?.receiptGroup ||
  //     null;

  //   const fromAppProps =
  //     window.App?.state?.props?.receiptgroupId ||
  //     window.App?.state?.props?.receiptGroupId ||
  //     (window.App?.state?.props?.receiptGroup && (window.App.state.props.receiptGroup.id || window.App.state.props.receiptGroup)) ||
  //     null;

  //   const rgId = fromFormData || fromAppProps;

  //   return rgId ? Number(rgId) : null;
  // };
  const itemActionBody = (rowData, row) => {
    return (
      <React.Fragment>
        <Button type="button" icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  let rgId = formData.receiptgroupId || 
                               formData.receipt_group?.id || 
                               (typeof formData.receipt_group === 'number' ? formData.receipt_group : null) ||
                               window.App.state.props?.receiptgroupId;

                  if (!rgId || !formData.id) {
                     return;
                  }
                  setItemFormData({ 
                      ...rowData, 
                      unit: rowData.unit?.id ?? rowData.unit ?? null,
                      rowIndex: row.rowIndex,
                      vat: rowData.vat_rate?.id
                  });

                  setItemFormMethod('update');
                  setItemDialog(true);

                  setItemFormMethod('update');
                  setItemDialog(true);
                  if (rowData.technologyName) setSelectedItemTechnology(rowData.technologyName);
                  if (rowData.costTypeName) setSelectedItemCosttype(rowData.costTypeName);
                }}
        />
        <Button type="button" icon="pi pi-trash" className="  p-button-danger p-mr-2"
                tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if (window.confirm('A törlés megerősítésére van szükség!')) {
                    deleteReceiptItem(formData.id, rowData.id)
                      .then(response => {
                        window.App.toastShow('success', 'Sikeres törlés!');
                        setFormData({});
                        closeReceipt(history);
                        const headers = {
                          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                          'App-Network': localStorage.getItem("networkId")
                        };
                        axios({
                            method: 'get',
                            url: process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + formData.id,
                            headers: headers
                        })
                          .then(response => {
                            const d = response.data?.data || response.data;
                            setFormData(prev => ({
                              ...prev,
                              ...d,
                              receiptgroupId: prev.receiptgroupId || window.App?.state?.props?.receiptgroupId || null
                            }));
                          })
                          .catch(error => {
                            window.App.toastShow('error', 'Hiba történt!', error.toString());
                          })
                      })
                      .catch(error => {
                        window.App.toastShow('error', 'Hiba történt!', error.toString());
                      })
                  }
                }}
        />


      </React.Fragment>
    );
  }

  // items
  const [itemDialog, setItemDialog] = useState(false);
  const [itemFormData, setItemFormData] = useState({}); // set on dialog open!
  const [itemFormMethod, setItemFormMethod] = useState('');


  // tétel hibakezelés
  const itemServerFieldMap = {
    vat_rate: 'vat',
    unit: 'unit',
    description: 'description',
    quantity: 'quantity',
    unit_price: 'unit_price',
    is_unit_price_gr: 'is_unit_price_gr'
  };

  const mapBackend400ToItemFormErrors = (error) => {
    if (error?.response?.status !== 400) return null;
    const fieldErrors = error?.response?.data?.data;
    if (!fieldErrors || typeof fieldErrors !== 'object') return null;
    const out = {};
    Object.keys(fieldErrors).forEach((key) => {
      const mappedKey = itemServerFieldMap[key] || key;
      const value = fieldErrors[key];
      out[mappedKey] = Array.isArray(value) ? value[0] : value;
    });
    return out;
  };

  const itemOnSubmit = (data, form) => {
    setLoading(true);
    const payload = {
      receipt: formData.id,
      unit: data.unit?.id || data.unit,
      vat_rate: data.vat,
      description: data.description,
      note: data.note || "",
      quantity: Number(data.quantity),
      unit_price: Number(data.unit_price),
      is_unit_price_gr: data.is_unit_price_gr || false
    };

    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    let promise;
    if (itemFormMethod === 'create') {
      promise = axios.post(`${process.env.REACT_APP_API_HOST}/api/v2/receipt-item`, payload, { headers });
    } else {
      const itemId = itemFormData.id; 
      promise = axios.patch(`${process.env.REACT_APP_API_HOST}/api/v2/receipt-item/${itemId}`, payload, { headers });
    }
    return promise
      .then(response => {
        window.App.toastShow('success', 'Sikeres mentés!');
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + formData.id,
          headers: headers
        }).then(res => {
          setFormData(res.data.data || res.data);
          setLoading(false);
          setItemDialog(false);
        });
      })
      // .catch(error => {
      //   window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      //   setLoading(false);
      // });
      .catch(error => {
        const mapped = mapBackend400ToItemFormErrors(error);
        if (mapped) {
          setLoading(false);
          return mapped;
        }
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        setLoading(false);
      });
  };

  // products autocomplete
  // const [products, setProducts] = useState([]);
  // const [selectedProduct, setSelectedProduct] = useState('');

  // const searchProducts = (event) => {
  //   ProductListService(
  //     {lazyEvent: JSON.stringify(event.name)}
  //   ).then(response => {
  //     setProducts(response.data.items)
  //   });
  // }


  // partners autocomplete
  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState('');


  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    if (q.length < 2) {
      setPartners([]);
      return;
    }
    // setLoading(true);
    setPartnerLoading(true);
    axios.get(
      process.env.REACT_APP_API_HOST +
        "/api/v2/partner?rows=15" +
        "&search[name][operator]=like" +
        "&search[name][value]=" + encodeURIComponent('%' + q + '%'),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("userToken"),
          "App-Network": localStorage.getItem("networkId"),
        },
      }
    )
    .then((response) => {
      const list = response?.data?.data?.items ?? [];
      const mapped = list.map((p) => ({
        ...p,
        name:
          p.name +
          (p.addressPostalCode || p.addressCity || p.addressDetail
            ? ` (${p.addressPostalCode ?? ""} ${p.addressCity ?? ""}, ${p.addressDetail ?? ""})`
            : ""),
      }));
      setPartners(mapped);
    })
    .catch((error) => {
      window.App.toastShow("error", t("error"), error.toString(), "", error.response);
    })
    .finally(() => setPartnerLoading(false));
  };

  const getSafeReceiptGroupId = (data = {}) => {
    const candidates = [
      data?.receiptgroupId,
      data?.receiptGroupId,
      data?.receipt_group?.id,
      data?.receiptGroup?.id,
      window.App?.state?.props?.receiptgroupId,
      window.App?.state?.props?.receiptGroupId,
      props?.initialValues?.receiptGroup?.id,
      props?.initialValues?.receiptGroupId,
      props?.initialValues?.receiptgroupId,
    ];
    const num = Number(candidates.find(v => v !== null && v !== undefined && String(v).trim() !== ''));
    return Number.isFinite(num) && num > 0 ? num : 1;
  };

  const fetchVatRateList = (queryOrParams = '') => {
    let query = queryOrParams;
    try {
      if (typeof queryOrParams === 'object' && queryOrParams !== null) {
        if (window.App && typeof window.App.transformQueryParams === 'function') {
          query = window.App.transformQueryParams(queryOrParams);
        } else {
          query = JSON.stringify(queryOrParams);
        }
      }
    } catch (e) {
      console.error('VatRateList query transform error:', e);
      query = queryOrParams;
    }
    if (query && query.toString().includes(',"multiSortMeta":[]')) {
      query = query.replace(',"multiSortMeta":[]', '');
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/vat-rate?" + (query || ''),
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const fetchBankaccountList = (queryOrParams = '') => {
    let query = queryOrParams;
    try {
      if (typeof queryOrParams === 'object' && queryOrParams !== null) {
        if (window.App && typeof window.App.transformQueryParams === 'function') {
          query = window.App.transformQueryParams(queryOrParams);
        } else {
          query = JSON.stringify(queryOrParams);
        }
      }
    } catch (e) {
      console.error('BankaccountList query transform error:', e);
      query = queryOrParams;
    }
    if (query && query.toString().includes(',"multiSortMeta":[]')) {
      query = query.replace(',"multiSortMeta":[]', '');
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/bank-account?" + (query || ''),
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const fetchReceiptFileBlobUrl = async (fileId) => {
    if (!fileId) return;
    revokeFileUrl(fileBlobUrl);
    setFileBlobUrl(null);
    const res = await axios.get(
      process.env.REACT_APP_API_HOST + `/api/v2/file/${fileId}/download`,
      {
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('userToken'),
          'App-Network': localStorage.getItem('networkId'),
        },
      }
    );
    const url = URL.createObjectURL(res.data);
    setFileBlobUrl(url);
  };

  const fetchCurrencyList = (queryOrParams = '') => {
    let query = queryOrParams;
    try {
      if (typeof queryOrParams === 'object' && queryOrParams !== null) {
        if (window.App && typeof window.App.transformQueryParams === 'function') {
          query = window.App.transformQueryParams(queryOrParams);
        } else {
          query = JSON.stringify(queryOrParams);
        }
      }
    } catch (e) {
      console.error('CurrencyList query transform error:', e);
      query = queryOrParams;
    }
    if (query && query.toString().includes(',"multiSortMeta":[]')) {
      query = query.replace(',"multiSortMeta":[]', '');
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/dictionary/currency?" + (query || ''),
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  // const fetchReceiptList = (queryOrParams) => {
  //   let query = queryOrParams;
  //   try {
  //     if (typeof queryOrParams === 'string' && queryOrParams.trim().startsWith('{')) {
  //       const parsed = JSON.parse(queryOrParams);
  //       if (window.App && typeof window.App.transformQueryParams === 'function') {
  //         query = window.App.transformQueryParams(parsed);
  //       } else {
  //         query = queryOrParams;
  //       }
  //     } else if (typeof queryOrParams === 'object' && queryOrParams !== null) {
  //       if (window.App && typeof window.App.transformQueryParams === 'function') {
  //         query = window.App.transformQueryParams(queryOrParams);
  //       } else {
  //         query = JSON.stringify(queryOrParams);
  //       }
  //     }
  //   } catch (e) {
  //     console.error('ReceiptListService query transform error:', e);
  //     query = queryOrParams;
  //   }
  //   if (query && query.toString().includes(',"multiSortMeta":[]')) {
  //     query = query.replace(',"multiSortMeta":[]', '');
  //   }
  //   return axios({
  //     method: 'get',
  //     url: process.env.REACT_APP_API_HOST + "/api/v2/receipt?" + query,
  //     params: {},
  //     headers: {
  //       'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
  //       'App-Network': localStorage.getItem("networkId")
  //     }
  //   });
  // };

  // receipt autocomplete
  // const [receipts, setReceipts] = useState([]);
  // const [selectedReceipt, setSelectedReceipt] = useState('');

  // const searchReceipt = (event) => {
  //   const cleanedQuery = event.query
  //     ? event.query.replace('Nincs találat', '').replace(': ', '') : '';
  //   setSelectedReceipt(cleanedQuery);
  //   fetchReceiptList(JSON.stringify({
  //     filters: {
  //       receiptNumber: {
  //         value: cleanedQuery
  //       }
  //     }
  //   }))
  //     .then(response => {
  //       const payload = response.data?.data || response.data;
  //       const items = payload?.items || [];
  //       if (items && items[0]) {
  //         setReceipts(items);
  //       } else {
  //         let string;
  //         if (cleanedQuery) {
  //           string = 'Nincs találat: ' + cleanedQuery;
  //         } else {
  //           string = 'Nincs találat';
  //         }
  //         setSelectedReceipt(string);
  //       }
  //     })
  //     .catch(error => {
  //       window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
  //     });
  // };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const actionButtons = (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '0.5rem',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap'
      }}
    >
      {formData.draft === true ? (
        <>
          {formData.id &&
            <>
              <Button
                label={t('view')}
                loading={loading}
                type="button"
                icon="pi pi-eye"
                className="p-button"
                onClick={() => {
                  window.App.setState({
                    sidebarReceiptUpdate: false,
                    props: null
                  });
                  setTimeout(() => {
                    history.push('/finance/receipt/read/' + formData.id);
                  }, 10);
                }}
              />

              <Button
                type="button"
                label={t('delete')}
                onClick={() => {
                  if (window.confirm('A törlés megerősítésére van szükség!')) {
                    setLoading(true)
                    axios.delete(process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + formData.id, {
                      headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                        'App-Network': localStorage.getItem("networkId")
                      }
                    })
                      .then(response => {
                        window.App.toastShow('success', 'Sikeres törlés!');
                            setFormData({});
                            closeReceipt(history);
                        window.App.setState({
                          rerenderReceiptList: true,
                          sidebarReceiptUpdate: false,
                          sidebarReceiptCreate: false,
                        })
                        setLoading(false)
                      })
                      .catch(error => {
                        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                        setLoading(false)
                      })
                  }
                }}
                loading={loading}
                icon="pi pi-trash"
                className="p-button-danger"
              />
            </>
          }
        </>
      ) : (
        <>
          {formData.external === true ? (
            <>
              {/*{formData.id &&*/}
              {/*<Button type="button" label={t('delete')}*/}
              {/* loading={loading}*/}
              {/* icon={"pi pi-trash"}*/}
              {/* className="p-button-danger disabled"/>*/}
              {/*}*/}
            </>
          ) : (
            <>
              {['CUSTOMER_INVOICE', 'CUSTOMER_ADVANCE_INVOICE'].includes(formData.receipt_type) &&
                <>
                  {(hasRole('ROLE_INVOICE_CORRECT') && formData.id && formData.correction !== true && formData.external === false && formData.storno !== true &&
                    !formData.reversed_receipt && !formData.storno_receipt) &&
                    <Button
                      type="button"
                      label={t('storno')}
                      onClick={() => {
                        if (window.confirm('Biztosan létrehozod a bizonylatot érvénytelenítő sztornóbizonylatot?')) {
                          setLoading(true)
                          axios.post(process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + formData.id + "/storno", {}, {
                            headers: {
                              'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                              'App-Network': localStorage.getItem("networkId")
                            }
                          })
                            .then(response => {
                              window.App.toastShow('success', 'Sikeres sztornózás!');
                              window.App.setState({
                                rerenderReceiptList: true,
                                sidebarReceiptUpdate: false,
                                sidebarReceiptCreate: false,
                              })
                              setLoading(false)
                              const stornoReceipt = response.data?.data;
                              if (stornoReceipt?.id) {
                                history.push('/finance/receipt/read/' + stornoReceipt.id);
                              }
                            })
                            .catch(error => {
                              window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                              setLoading(false)
                            })
                        }
                      }}
                      loading={loading}
                      icon="pi pi-replay"
                      className="p-button-danger"
                    />
                  }
                </>
              }


            </>
          )}
        </>
      )}

      {formData.draft !== false && (
        <Button
          type="submit"
          label={t('save')}
          id="submit"
          loading={loading}
          onClick={() => {
            submitActionRef.current = 'save';
          }}
          icon="pi pi-check"
          className="p-button-success"
        />
      )}

      {formData.id && formData.draft === true && (
        <>
          {external === false && hasRole('ROLE_RECEIPT_WRITE') && (!formData.correction || hasRole('ROLE_INVOICE_CORRECT')) &&
            ['CUSTOMER_INVOICE', 'CUSTOMER_PROFORMA', 'CUSTOMER_ADVANCE_INVOICE'].includes(formData.receipt_type) &&
            formData.items?.length > 0 && (
              <Button
                type="submit"
                label={t('saveAndIssueDocument')}
                id="submit-finalize-customer"
                onClick={() => {
                  submitActionRef.current = 'save-and-finalize';
                }}
                loading={loading}
                icon="pi pi-check"
                className="p-button-success"
              />
            )
          }

          {external === true &&
            ['CUSTOMER_INVOICE', 'CUSTOMER_PROFORMA', 'CUSTOMER_ADVANCE_INVOICE', 'SUPPLIER_INVOICE', 'SUPPLIER_PROFORMA', 'SUPPLIER_ADVANCE_INVOICE'].includes(formData.receipt_type) &&
            formData.items?.length > 0 && (
              <Button
                type="submit"
                label={t('saveAndCloseDocument')}
                id="submit-finalize-supplier"
                onClick={() => {
                  submitActionRef.current = 'save-and-close';
                }}
                loading={loading}
                icon="pi pi-lock"
                className="p-button-warning"
              />
            )
          }
        </>
      )}
    </div>
  );

  // company autocomplete
  const [companies, setCompanies] = useState([]);
  //if cost
  const [selectedCompany, setSelectedCompany] = useState('');


  // paymentMethod autocomplete
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();


  // costtype autocomplete
  const [selectedItemCosttype, setSelectedItemCosttype] = useState('');

  // const searchItemCosttype = (event) => {
  //   CosttypeListService(JSON.stringify({filters: {name: {value: event.query}}}))
  //     .then(response => {
  //       setCosttypes(response.data.items)
  //     })
  //     .catch(error => {
  //       window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
  //     })
  // }

  // project autocomplete
  // const [projects, setProjects] = useState([]);
  const [selectedItemProject, setSelectedItemProject] = useState();

  // const searchItemProject = (event) => {
  //   ProjectListService(JSON.stringify({filters: {name: {value: event.query}}}))
  //     .then(response => {
  //       if (response.data && response.data.items && response.data.items[0]) {
  //         let _projects = []
  //         Object.entries(response.data.items).map(function (project, index) {
  //           _projects.push({
  //             name: project[1].projectNumber + " (" + project[1].name + ")",
  //             id: project[1].id
  //           })
  //         })
  //         setProjects(_projects)
  //       }
  //     })
  //     .catch(error => {
  //       window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
  //     })
  // }

  // technology autocomplete
  // const [technologies, setTechnologies] = useState([]);
  const [selectedItemTechnology, setSelectedItemTechnology] = useState();

  // const searchItemTechnology = (event) => {
  //   TechnologyListService(JSON.stringify({filters: {name: {value: event.query}}}))
  //     .then(response => {
  //       setTechnologies(response.data.items)
  //     })
  //     .catch(error => {
  //       window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
  //     })
  // }

  const priceFormatter = (price) => {
    return <span className={""}>{formatCurrency(formData.currency, price)}</span>
  }

  const downloadFileAsBlobUrl = async (fileId) => {
    if (!fileId) return;
    setFileBlobUrl((prev) => {
      revokeFileUrl(prev);
      return null;
    });
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + `/api/v2/file/${fileId}/download`,
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
            'App-Network': localStorage.getItem('networkId'),
          },
        }
      );
      const blobUrl = URL.createObjectURL(res.data);
      setFileBlobUrl(blobUrl);
    } catch (err) {
      window.App.toastShow('error', t('error'), err.toString(), '', err.response);
    }
  };

  useEffect(() => {
    return () => {
      revokeFileUrl(fileBlobUrl);
    };
  }, []);

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/language?item_per_page=200&sort=name&direction=asc', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('userToken'),
        'App-Network': localStorage.getItem('networkId'),
      },
    }).then(response => {
      setLanguages(response?.data?.data?.items || []);
    }).catch(() => {
      setLanguages([
        {name: 'Magyar', code: 'hu'},
        {name: 'Angol', code: 'en'},
      ]);
    });
  }, []);

  const uploadReceiptFileNow = async ({ files }) => {
    const f = files?.[0];
    if (!f) return;
    setFileUploadError(null);
    setFileUploading(true);
    setFileUploadProgress(0);
    try {
      const fd = new FormData();
      fd.append('file', f);
      const up = await axios.post(
        process.env.REACT_APP_API_HOST + '/api/v2/file/upload',
        fd,
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
            'App-Network': localStorage.getItem('networkId'),
          },
          onUploadProgress: (evt) => {
            if (!evt.total) return;
            const percent = Math.round((evt.loaded * 100) / evt.total);
            setFileUploadProgress(percent);
          },
        }
      );
      const newId = up?.data?.data?.id ?? up?.data?.id;
      if (!newId) throw new Error('Nem érkezett file id a feltöltésből.');
      setFormData((prev) => ({ ...prev, file: Number(newId) }));
      setUploadedFile({ id: Number(newId) });
      fileUploadRef.current?.clear();
      await fetchReceiptFileBlobUrl(Number(newId));
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.response?.data?.message || err.toString();
      setFileUploadError(msg);
      window.App.toastShow('error', t('error'), msg, '', err.response);
    } finally {
      setFileUploading(false);
    }
  };

  // useEffect(() => {
  //   setFormData({
  //     ...formData,
  //     partner: {id: Number(window.App.state.newPartnerId)}
  //   })
  //   setSelectedPartner(window.App.state.newPartnerName)
  // }, [window.App.state.newPartnerId])
  useEffect(() => {
    const id = Number(window.App.state.newPartnerId) || null;
    const name = window.App.state.newPartnerName || '';
    if (!id) return;
    setFormData((prev) => ({
      ...prev,
      partner: id,
      partnerName: name,
    }));
    setPartnerDisplayValue(name);
  }, [window.App.state.newPartnerId]);


  const deleteReceiptItem = (receiptId, itemId) => {
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API_HOST + "/api/v2/receipt-item/" + itemId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const mapReceiptData = (rawData) => {
    if (!rawData) return {};
    return {
      ...rawData,
      receiptType: rawData.receipt_type,
      // partnerNote: rawData.partner_note,
      partnerNote: rawData.partner_note ?? rawData.note ?? '',
      note: rawData.note ?? '',
      issueDate: rawData.issue_date,
      deliveryDate: rawData.delivery_date,
      paymentDate: rawData.payment_date,
      netAmount: rawData.net_amount,
      vatAmount: rawData.vat_amount,
      grossAmount: rawData.gross_amount,
      partner: rawData.partner?.id || rawData.partner,
      company: rawData.company?.id || rawData.company,
      paymentMethod: rawData.payment_method?.id || rawData.payment_method,
    };
  };

  useEffect(() => {
    if (!isCustomerReceipt || !financePermissions().readReceiptAllocations) return;
    if (!formData?.id) return;
    if (!isRevenuePosted) return;
    fetchRevenueAllocationSummary(formData.id)
      .then(res => {
        const data = res.data?.data || [];
        setRevenueAllocationSummary(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
  }, [formData?.id, isRevenuePosted, isCustomerReceipt]);

  useEffect(() => {
    setLoading(true);
    const receiptId = props.initialValues?.id || window.App.urlVars().receiptId;
    if (receiptId) {
      const headers = {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      };
      axios.get(`${process.env.REACT_APP_API_HOST}/api/v2/receipt/${receiptId}`, { headers })
        .then(response => {
          const raw = response.data?.data || response.data;
          if (raw?.correction) {
            history.replace(`/finance/receipt/read/${raw.id}`);
            return;
          }
          const mappedData = mapReceiptData(raw);          
          setFormData(mappedData);
          setPartnerDisplayValue(mappedData.partner_name || '');
          const fid = raw?.file?.id ?? raw?.file ?? null;
          if (fid) fetchReceiptFileBlobUrl(Number(fid));
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba', 'Nem sikerült betölteni az adatokat');
        })
        .finally(() => setLoading(false));
    }
  }, [props.initialValues?.id]);

  useEffect(() => {
      setLoading(true);
      fetchCompanyListSimple()
      .then(res => {
        const data = res.data?.data || res.data;
        const items = Array.isArray(data) ? data : (data.items || []);
        setCompanies(items);
      })
      .catch(err => {
        window.App.toastShow('error', 'Hiba történt!', err.toString(), '', err.response);
      });
      fetchPaymentMethodListSimple()
      .then(res => {
        const data = res.data?.data || res.data;
        const items = Array.isArray(data) ? data : (data.items || []);
        setPaymentMethods(items);
      })
      .catch(err => {
        window.App.toastShow('error', 'Hiba történt!', err.toString(), '', err.response);
      });
      fetchBankaccountList(JSON.stringify({
        first: 0,
        rows: 100,
        page: 0,
      }))
        .then(response => {
          const data = response.data?.data || response.data;
          const items = data?.items || response.data.items || [];
          setBankAccounts(items);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        });

      const headers = {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      };

      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/receipt-group",
        // params: {
        //   first: 0,
        //   rows: 9999,
        //   page: 0,
        // },
        headers: headers,
      })
        .then(response => {
          const data = response.data?.data || response.data;
          const items = data?.items || (Array.isArray(data) ? data : []);
          setReceiptgroups(items);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        });

      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/unit?search[finance][operator]==&search[finance][value]=true",
        headers: headers,
      })
      .then(response => {
        setUnits(response.data?.data?.items);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
      fetchCurrencyList('')
        .then(response => {
          const data = response.data?.data || response.data;
          const items = Array.isArray(data) ? data : (data.items || []);
          setCurrencies(items);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        });

      fetchVatRateList('')
        .then(response => {
          const data = response.data?.data || response.data;
          const items = Array.isArray(data) ? data : (data.items || []);
          setVats(items);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        });


        if (props && props.initialValues) {
          axios({
            method: 'get',
            url: process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + props.initialValues.id,
            params: {},
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
              'App-Network': localStorage.getItem("networkId")
            }
          })
        .then(response => {
      const receipt = {
        ...response.data?.data,
        companyName: response.data?.data.company_name,
        companyVatNumber: response.data?.data.company_vat_number,
        companyCommunityVatNumber: response.data?.data.company_community_vat_number,
        companyAddressCountryCode: response.data?.data.company_address_country_code,
        companyAddressPostalCode: response.data?.data.company_address_postal_code,
        companyAddressCity: response.data?.data.company_address_city,
        companyAddressDetail: response.data?.data.company_address_detail,

        partnerName: response.data?.data.partner_name,
        partnerVatNumber: response.data?.data.partner_vat_number,
        partnerCommunityVatNumber: response.data?.data.partner_community_vat_number,
        partnerAddressCountryCode: response.data?.data.partner_address_country_code,
        partnerAddressPostalCode: response.data?.data.partner_address_postal_code,
        partnerAddressCity: response.data?.data.partner_address_city,
        partnerAddressDetail: response.data?.data.partner_address_detail,

        receiptNumber: response.data?.data.receipt_number,
        receiptType: response.data?.data.receipt_type,
        external: response.data?.data.external,
        receiptGroup: response.data?.data.receipt_group,

        issue_date: response.data?.data.issue_date,
        delivery_date: response.data?.data.delivery_date,
        payment_date: response.data?.data.payment_date,

        currency: response.data?.data.currency,
        exchangeRate: response.data?.data.exchange_rate,
        exchange_rate: response.data?.data.exchange_rate,
        ...billingFields(response.data?.data || {}),

        paymentMethod: response.data?.data.payment_method
          ? { id: response.data?.data.payment_method.id }
          : null,

        items: (response.data?.data.items || []).map(item => ({
          ...item,
          unitName: item.unit_name,
          unitPrice: item.unit_price,
          netAmount: item.net_amount,
          vatAmount: item.vat_amount,
          grossAmount: item.gross_amount,
        })),

        netAmount: response.data?.data.net_amount ?? response.data?.data.net_amount_h_u_f,
        vatAmount: response.data?.data.vat_amount ?? response.data?.data.vat_amount_h_u_f,
        grossAmount: response.data?.data.gross_amount ?? response.data?.data.gross_amount_h_u_f,

        language: response.data?.data.language,
      };
          const fid = response.data?.data?.file?.id ?? response.data?.data?.file ?? null;
          if (fid) {
            setFileBusy(true);
            fetchReceiptFileBlobUrl(Number(fid))
              .catch((err) => console.error('File download error', err))
              .finally(() => setFileBusy(false));
          } else {
            setFileBusy(false);
            setFileBlobUrl((prev) => {
              revokeFileUrl(prev);
              return null;
            });
            setUploadedFile(null);
          }
          setSelectedPartner(receipt.partnerName);
          setSelectedCompany(receipt.companyName);
          setSelectedPaymentMethod(receipt.paymentMethodName);
          setSelectedItemCosttype(receipt.costTypeName);
          if (props.initialValues.vat) {
            const vatId = receipt.vat;
            fetchVatRateList('')
              .then(response2 => {
                const vatData = response2.data?.data || response2.data;
                const vatList = Array.isArray(vatData) ? vatData : (vatData.items || []);
                const vatPercent = vatList.filter(vat => vat.id === vatId);
                if (vatPercent[0]) {
                  setTotVat({
                    percent: Number(vatPercent[0].percentage),
                    name: vatPercent[0].name,
                    id: vatId
                  });
                }
              })
              .catch(error => {
                window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
              });
          }
          // setFormData(receipt);
          const appRgId = window.App?.state?.props?.receiptgroupId || window.App?.state?.props?.receiptGroupId || null;
          const apiRgId = response.data?.data?.receipt_group ? (response.data.data.receipt_group.id || response.data.data.receipt_group) : null;

          setFormData({
            ...receipt,
            receiptgroupId: apiRgId || appRgId
          });
        })
        .catch(error => {
          if ([404, 410].includes(error.response?.status)) { setUnavailable(true); return; }
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      let _formData = {}
      _formData = {
        ..._formData,
        company: {id: Number(localStorage.getItem('defaultCompanyId'))},
      }
      // setFormData({
      //    ...formData,
      //    company: {id: Number(localStorage.getItem('defaultCompanyId'))},
      //    paymentMethod: {id: Number(localStorage.getItem('defaultPaymentMethodId'))},
      // })
      setSelectedCompany(localStorage.getItem('defaultCompanyName'))
      // if (window.App.state.props && window.App.state.props.receiptType === 'cost' && localStorage.getItem('defaultReceiptCostGroupId')) {
      //    _formData = {
      //      ..._formData,
      //      receiptGroup: {id: Number(localStorage.getItem('defaultReceiptCostGroupId'))},
      //    }
      //    // setFormData({
      //    //    ...formData,
      //    //    receiptGroup: {id: Number(localStorage.getItem('defaultReceiptCostGroupId'))},
      //    // })
      // }
      // if (localStorage.getItem('defaultProjectName') && localStorage.getItem('defaultProjectId')) {
      //    setSelectedProject(localStorage.getItem('defaultProjectName'))
      //    _formData = {
      //      ..._formData,
      //      project: {
      //        id: Number(localStorage.getItem('defaultProjectId'))
      //      }
      //    }
      //    // setFormData({
      //    //    ...formData,
      //    //    project: {
      //    //      id: Number(localStorage.getItem('defaultProjectId'))
      //    //    }
      //    // })
      // }
      if (localStorage.getItem('defaultCurrencyCode')) {
        _formData = {
          ..._formData,
          currency: localStorage.getItem('defaultCurrencyCode')
        }
      }
      if (window.App.state.props && (window.App.state.props.receiptgroupId || window.App.state.props.receiptGroupId)) {
        const rgIdFromApp = window.App.state.props.receiptgroupId || window.App.state.props.receiptGroupId;
        _formData = {
          ..._formData,
          receiptgroupId: Number(rgIdFromApp),
          receiptGroup: {
            id: Number(rgIdFromApp)
          }
        }
      }
      setFormData({
        ..._formData,
        currency: "HUF",
        missingContract: false,
        vat: 10
      })
      const defaultHeaders = {
        Authorization: 'Bearer ' + localStorage.getItem('userToken'),
        'App-Network': localStorage.getItem('networkId')
      };
      Promise.all([
        axios.get(process.env.REACT_APP_API_HOST + '/api/v2/network/settings', {headers: defaultHeaders}),
        _formData.receiptgroupId
          ? loadLookupRecord((method, path) => axios.get(process.env.REACT_APP_API_HOST + path, {headers: defaultHeaders}), 'receipt-group', _formData.receiptgroupId, 'ROLE_RECEIPT_GROUP_READ')
          : Promise.resolve(null)
      ]).then(([settings, group]) => {
        const method = group?.data?.data?.default_payment_method ?? settings.data?.data?.default_payment_method;
        if (method?.id) {
          setFormData(previous => previous.paymentMethod || previous.payment_method ? previous : {
            ...previous, paymentMethod: method.id, payment_method: method
          });
        }
      }).catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
      setLoading(false)
    }
  }, [])

  // useEffect(() => {
  //   const urlVars = window.App.urlVars();
  //   if (urlVars.partnerId && urlVars.partnerName) {
  //     const id = Number(urlVars.partnerId) || null;
  //     const name = decodeURIComponent(urlVars.partnerName || '');
  //     setPartnerDisplayValue(name);
  //     setFormData((prev) => ({
  //       ...prev,
  //       partner: id,
  //       partnerName: name,
  //     }));
  //   }
  // }, [window.App.urlVars().partnerName, window.App.urlVars().partnerId]);

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.partnerId && urlVars.partnerName) {
      const id = Number(urlVars.partnerId) || null;
      const name = decodeURIComponent(urlVars.partnerName || '');
      setPartnerDisplayValue(name);
      if (!id) return;
      const headers = {
        Authorization: 'Bearer ' + localStorage.getItem('userToken'),
        'App-Network': localStorage.getItem('networkId')
      };
      loadLookupRecord((method, url) => axios.get(process.env.REACT_APP_API_HOST + url, {headers}), 'partner', id, 'ROLE_PARTNER_READ')
        .then((response) => {
          const partner = response.data?.data || response.data;
          setSelectedPartnerData(partner);
          const calculatedPaymentDate = shouldCalculatePaymentDate(partner, formData.payment_date, formData.issue_date)
            ? calculatePartnerPaymentDate(partner, formData.issue_date)
            : null;
          setFormData((prev) => ({
            ...prev,
            partner: id,
            partnerName: name,
            partnerVatNumber: partner?.vat_number ?? partner?.vatNumber,
            partnerAddressPostalCode: partner?.address_postal_code ?? partner?.addressPostalCode,
            partnerAddressCity: partner?.address_city ?? partner?.addressCity,
            partnerAddressDetail: partner?.address_detail ?? partner?.addressDetail,
            ...(calculatedPaymentDate
              ? { payment_date: calculatedPaymentDate }
              : {})
          }));
        })
        .catch((error) => {
          setFormData((prev) => ({
            ...prev,
            partner: id,
            partnerName: name,
          }));
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        });
    }
  }, [window.App.urlVars().partnerName, window.App.urlVars().partnerId]);

  useEffect(() => {
    if (!partnerDisplayValue && formData?.partnerName) {
      setPartnerDisplayValue(formData.partnerName);
    }
  }, [formData.partnerName, partnerDisplayValue]);

  useEffect(() => {
    if (partnerAddresses && partnerAddresses[0] && formData.partnerShippingAddress && formData.partnerShippingAddress.id) {
      let shippingAddress = partnerAddresses.filter(item => item.id === formData.partnerShippingAddress.id)
      setShippingAddress(shippingAddress[0])
    }
  }, [formData.partnerShippingAddress, partnerAddresses])


  useEffect(() => {
    if (!isSupplierReceipt || !financePermissions().readReceiptAllocations) return;
    if (!formData?.id) return;
    if (!isCostPosted) return;
    fetchCostAllocationSummary(formData.id)
      .then(res => {
        const data = res.data?.data || [];
        setCostAllocationSummary(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
  }, [formData?.id, isCostPosted, isSupplierReceipt]);



  if (unavailable) return <ReceiptUnavailable />;

  return (
    <>
      {!formData.id && loading === true ? (
        <>
          <span className={"p-d-block p-py-4"} style={{fontSize: '1.5em'}}>
            <i className="pi pi-spin pi-spinner" style={{fontSize: '0.9em'}}></i>
            &nbsp;Betöltés...
          </span>
        </>
      ) : (
        <>
          <h2 className={"text-primary p-mb-0"}>{receiptFormTitle}</h2>
          <div className={"p-grid p-mb-2"}>
            {window.App.state.props && window.App.state.props.receiptGroupName &&
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>
                  {t('receiptGroupLabel')}
                </small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  <>{window.App.state.props.receiptGroupName}</>
                </p>
              </div>
            }
            {window.App.state.props && window.App.state.props.name &&
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>
                  {t('receiptGroupLabel')}
                </small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  <>{window.App.state.props.name}</>
                </p>
              </div>
            }
            {window.App.state.props && window.App.state.props.receiptType &&
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>
                  Típus
                </small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {window.App.state.props.receiptType === 'invoice' && window.App.state.props.outgoing === true &&
                    <>{t('receiptInvoice')}</>
                  }
                  {window.App.state.props.receiptType === 'invoice' && window.App.state.props.outgoing === false &&
                    <>{t('receiptCostInvoice')}</>
                  }
                  {window.App.state.props.receiptType === 'fee_request' &&
                    <>{t('receiptFeeRequest')}</>
                  }
                  {window.App.state.props.receiptType === 'delivery_note' &&
                    <>{t('receiptDeliveryNote')}</>
                  }
                </p>
              </div>
            }
          </div>
          <Form onSubmit={onSubmit} initialValues={formData}
                validate={validate} render={({handleSubmit, submitting, submitFailed, form, values}) => (
            <form onSubmit={handleSubmit} className="">
              <Panel
                //    headerTemplate={
                //    <div className={"p-grid"}>
                //      <div className={"p-col-12"}>
                //        <h3>
                //          <i className={"pi pi-list"}></i> Fej adatok
                //        </h3>
                //      </div>
                //    </div>
                // }
                className={""}>
                <div className={"p-grid"}>
                  {showReceiptNumber &&
                    <div className={"p-col-12 p-lg-2 p-xl-2"}>
                      <Field name="receipt_number" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <label htmlFor="costType"
                                 className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'receipt_number')})}>{props.t('fieldSerialNumber')}</label>
                          <span className={"p-d-block"}>
                        <InputText id="receipt_number" {...input}
                                   onChange={(e) => {
                                    input.onChange(e.target.value);
                                    setFormData(prev => ({
                                      ...prev,
                                      receipt_number: e.target.value
                                    }));
                                  }}
                                   value={input.value ?? ''} 
                                   className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'receipt_number')})}/>
                            </span>
                          {getFormErrorMessage(meta, submitFailed, 'receipt_number')}
                        </div>
                      )}/>
                    </div>
                  }
                  <div className={"p-col-12 p-lg-2"}>
                    <Field name="company" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="company"
                               className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'company')})}>
                          {uiOutgoing === false ? (
                            <>{t('customerLabel')}</>
                          ) : (
                            <>{t('supplierLabel')}</>
                          )}
                        </label>
                        <span className={"p-d-block"}>
                          <Dropdown
                            id="company"
                            value={formData?.company?.id ?? null}
                            options={window.App.sortDropdownOptions(companies, "name")}
                            optionLabel="name"
                            optionValue="id"
                            placeholder={t('selectPlaceholder')}
                            className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'company')})}
                            onChange={(e) => {
                              const id = e.value ? Number(e.value) : null;
                              setFormData(prev => ({ ...prev, company: id ? { id } : { id: null } }));
                              const selected = companies.find(c => c.id === id);
                              if (selected) {
                                localStorage.setItem('defaultCompanyId', String(selected.id));
                                localStorage.setItem('defaultCompanyName', selected.name);
                              }
                            }}
                          />
                        </span>
                        {getFormErrorMessage(meta, submitFailed, 'company')}
                      </div>
                    )}/>
                  </div>
                  <div className={"p-col"}>
                    <Field
                      name="partner"
                      render={({ input, meta }) => (
                        <div className="p-field p-fluid">
                          <label
                            htmlFor="partner"
                            className={classNames({ 'p-error': isFormFieldValid(meta, submitFailed, 'partner') })}
                          >
                            {uiOutgoing === false ? <>{t('supplierLabel')}</> : <>{t('customerLabel')}</>}
                          </label>
                          <span className="p-inputgroup">
                            <Button
                              type="button"
                              className="p-button p-button-icon-only p-button-primary"
                              onClick={() => {
                                let _params = "?";
                                Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                                  _params += key + "=" + value + "&";
                                });
                                _params += "search=partner";
                                window.location.hash = window.location.hash.replace(/\?.*$/, "") + _params;
                              }}
                              tooltipOptions={{ position: 'top' }}
                            >
                              <i className="pi pi-search"></i>
                            </Button>

                            <AutoComplete
                              id="partner"
                              loading={partnerLoading}
                              value={partnerDisplayValue}
                              suggestions={partners}
                              completeMethod={searchPartner}
                              field="name"
                              delay={700}
                              placeholder={t('typeToSearchPlaceholder')}
                              className={classNames({ 'p-invalid': isFormFieldValid(meta, submitFailed, 'partner') })}
                              onSelect={(e) => {
                                const p = e.value;
                                if (!p?.id) return;
                                const calculatedPaymentDate = shouldCalculatePaymentDate(p, formData.payment_date, formData.issue_date)
                                  ? calculatePartnerPaymentDate(p, formData.issue_date)
                                  : null;
                                setSelectedPartnerData(p);
                                setPartnerDisplayValue(p.name);
                                input.onChange(Number(p.id));
                                if (calculatedPaymentDate && form) {
                                  form.change('payment_date', calculatedPaymentDate);
                                }
                                setFormData((prev) => ({
                                  ...prev,
                                  partner: Number(p.id),
                                  partnerName: p.name,
                                  partnerVatNumber: p.vat_number ?? p.vatNumber,
                                  partnerAddressPostalCode: p.address_postal_code ?? p.addressPostalCode,
                                  partnerAddressCity: p.address_city ?? p.addressCity,
                                  partnerAddressDetail: p.address_detail ?? p.addressDetail,
                                  ...(calculatedPaymentDate
                                    ? { payment_date: calculatedPaymentDate }
                                    : {})
                                }));
                              }}
                              onChange={(e) => {
                                setPartnerDisplayValue(e.value);
                                if (!e.value || String(e.value).trim() === '') {
                                  setSelectedPartnerData(null);
                                  input.onChange(null);
                                  setFormData((prev) => ({
                                    ...prev,
                                    partner: null,
                                    partnerName: null,
                                    partnerVatNumber: null,
                                    partnerAddressPostalCode: null,
                                    partnerAddressCity: null,
                                    partnerAddressDetail: null,
                                  }));
                                }
                              }}
                              onClear={() => {
                                setPartnerDisplayValue('');
                                setSelectedPartnerData(null);
                                input.onChange(null);
                                setFormData((prev) => ({
                                  ...prev,
                                  partner: null,
                                  partnerName: null,
                                  partnerVatNumber: null,
                                  partnerAddressPostalCode: null,
                                  partnerAddressCity: null,
                                  partnerAddressDetail: null,
                                }));
                              }}
                            />

                            <Sidebar
                              position="left"
                              visible={window.App.state.sidebarPartnerCreate}
                              closeOnEscape={true}
                              style={{ width: '780px' }}
                              onHide={() => window.App.setState({ sidebarPartnerCreate: false })}
                            >
                              <h2 className={"text-primary"}>{props.t('addPartner')}</h2>
                              <PartnerFormComponent method="post" pick={true} />
                            </Sidebar>
                            <Button
                              type="button"
                              icon="pi pi-plus"
                              className="p-button p-button-icon-only"
                              onClick={() => window.App.setState({ sidebarPartnerCreate: true })}
                              tooltip={t('addPartner')}
                              tooltipOptions={{ position: 'top' }}
                            />
                          </span>

                          {getFormErrorMessage(meta, submitFailed, 'partner')}
                        </div>
                      )}
                    />
                  </div>
                  {window.App.state.props.receiptType === 'delivery_note' && window.App.state.props.outgoing === true &&
                    <>
                      {formData.partner && formData.partner.id ? (
                        <div className={"p-col-12 p-lg-4 p-xl-4"}>
                          <div className="p-field p-fluid">
                            <label htmlFor="code">{props.t('fieldDeliveryAddress')}</label>
                            <span className="p-d-block">
                            {formData && formData.partnerShippingAddress && formData.partnerShippingAddress.id ? (
                              <Dropdown options={window.App.sortDropdownOptions(partnerAddresses, "fullAddress")}
                                        optionLabel="fullAddress"
                                        optionValue="id"
                                        emptyMessage={"Még nincs felvéve további cím a partnerhez..."}
                                        onChange={(e) => {
                                          let shippingAddress = partnerAddresses.filter(item => item.id === e.value)
                                          setShippingAddress(shippingAddress[0])
                                          setFormData({
                                            ...formData,
                                            partnerShippingAddress: {id: e.value},
                                          })
                                        }}
                                        value={formData.partnerShippingAddress.id}
                              />
                            ) : (
                              <Dropdown options={window.App.sortDropdownOptions(partnerAddresses, "fullAddress")}
                                        optionLabel="fullAddress"
                                        optionValue="id"
                                        emptyMessage={"Még nincs felvéve további cím a partnerhez..."}
                                        onChange={(e) => {
                                          let shippingAddress = partnerAddresses.filter(item => item.id === e.value)
                                          setShippingAddress(shippingAddress[0])
                                          setFormData({
                                            ...formData,
                                            partnerShippingAddress: {id: e.value},
                                          })
                                        }}
                                        value={null}
                              />
                            )}

                          </span>
                          </div>
                        </div>
                      ) : (
                        <div className={"p-col-12 p-lg-4 p-xl-4"}>
                          <div className="p-field p-fluid">
                            <label htmlFor="code">{props.t('fieldDeliveryAddress')}</label>
                            <span className="p-d-block">
                            <Dropdown disabled/>
                          </span>
                          </div>
                        </div>
                      )}
                    </>
                  }



                  <div className={"p-col-12 p-lg-2 p-xl-1"} style={{minWidth: '160px'}}>
                    <Field name="delivery_date" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="delivery_date"
                                className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'delivery_date')})}>{props.t('fieldDeliveryDate')}</label>
                        <span className="">
                        <div className="p-inputgroup calendar-icon-only">
                          <InputMask id={"delivery_date"}
                                      mask={"9999-99-99"}
                                      placeholder={"ÉÉÉÉ-HH-NN"}
                                      value={formData.delivery_date}
                                      onChange={(e) => {
                                        if (e.value.indexOf("_") === -1) {
                                          if (e.value === '') {
                                            e.value = null
                                          }
                                          setFormData({
                                            ...formData,
                                            delivery_date: e.value
                                          })
                                        }
                                      }}
                          />
                          <Calendar value={formData.delivery_date}
                                    locale="hu"
                                    format={'yy-mm-dd'}
                                    showIcon
                                    minDate={calendarMinDate}
                                    maxDate={calendarMaxDate}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        delivery_date: moment(e.value).format('YYYY-MM-DD')
                                      })
                                    }}/>
                        </div>
                      </span>
                        {getFormErrorMessage(meta, submitFailed, 'delivery_date')}
                      </div>
                    )}/>
                  </div>

                  {uiExternal &&
                    <div className={"p-col-12 p-lg-2  p-xl-1"} style={{minWidth: '160px'}}>
                      <Field name="issue_date" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <label htmlFor="issue_date"
                                 className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'issue_date')})}>{props.t('fieldIssueDate')}</label>
                          <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"issue_date"}
                                       mask={"9999-99-99"}
                                       placeholder={"ÉÉÉÉ-HH-NN"}
                                       value={formData.issue_date}
                                       onChange={(e) => {
                                        if (e.value.indexOf("_") === -1) {
                                          const newIssueDate = e.value === '' ? null : e.value;
                                          const calculatedPaymentDate = shouldCalculatePaymentDate(
                                            selectedPartnerData,
                                            formData.payment_date,
                                            newIssueDate
                                          )
                                            ? calculatePartnerPaymentDate(selectedPartnerData, newIssueDate)
                                            : null;
                                          setFormData({
                                            ...formData,
                                            issue_date: newIssueDate,
                                            ...(calculatedPaymentDate
                                              ? { payment_date: calculatedPaymentDate }
                                              : {})
                                          });
                                        }
                                      }}
                            />
                            <Calendar value={formData.issue_date}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      minDate={calendarMinDate}
                                      maxDate={calendarMaxDate}
                                      onChange={(e) => {
                                        const newIssueDate = moment(e.value).format('YYYY-MM-DD');
                                        const calculatedPaymentDate = shouldCalculatePaymentDate(
                                          selectedPartnerData,
                                          formData.payment_date,
                                          newIssueDate
                                        )
                                          ? calculatePartnerPaymentDate(selectedPartnerData, newIssueDate)
                                          : null;
                                        setFormData({
                                          ...formData,
                                          issue_date: newIssueDate,
                                          ...(calculatedPaymentDate
                                            ? { payment_date: calculatedPaymentDate }
                                            : {})
                                        });
                                      }}/>
                          </div>
                        </span>
                          {getFormErrorMessage(meta, submitFailed, 'issue_date')}
                        </div>
                      )}/>
                    </div>
                  }

                  <div className={"p-col-12 p-lg-2  p-xl-1"} style={{minWidth: '160px'}}>
                    <Field name="payment_date" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="payment_date"
                                className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'payment_date')})}>{props.t('fieldPaymentDate')}</label>
                        <span className="">
                        <div className="p-inputgroup calendar-icon-only">
                          <InputMask id={"payment_date"}
                                      mask={"9999-99-99"}
                                      placeholder={"ÉÉÉÉ-HH-NN"}
                                      value={formData.payment_date}
                                      onChange={(e) => {
                                        if (e.value.indexOf("_") === -1) {
                                          if (e.value === '') {
                                            e.value = null
                                          }
                                          setFormData({
                                            ...formData,
                                            payment_date: e.value
                                          })
                                        }
                                      }}
                          />
                          <Calendar value={formData.payment_date}
                                    locale="hu"
                                    format={'yy-mm-dd'}
                                    showIcon
                                    minDate={calendarMinDate}
                                    maxDate={calendarMaxDate}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        payment_date: moment(e.value).format('YYYY-MM-DD')
                                      })
                                    }}/>
                        </div>
                      </span>
                        {getFormErrorMessage(meta, submitFailed, 'payment_date')}
                      </div>
                    )}/>
                  </div>

                  <div className={"p-col-12 p-lg-2 p-xl-1"}>
                    <Field name="currency" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="currency"
                                className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'currency')})}>{props.t('fieldCurrency')}</label>
                        <span className={"p-d-block"}>
                            <Dropdown {...input}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          currency: e.target.value
                                        })
                                        localStorage.setItem('defaultCurrencyCode', e.target.value)
                                      }}
                                      value={formData.currency}
                                      options={window.App.sortDropdownOptions(currencies, "key")}
                                      optionLabel="key"
                                      optionValue="key"
                                      id={"currency"}
                                      emptyMessage={"Még nincs pénznem..."}
                                      className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'currency')})}
                            />
                          </span>
                        {getFormErrorMessage(meta, submitFailed, 'currency')}
                      </div>
                    )}/>
                  </div>



                  <div className={"p-col-12 p-lg-2"}>
                    <Field name="payment_method" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="payment_method"
                                className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'payment_method')})}>{props.t('fieldPaymentMethod')}</label>
                        <span className={"p-d-block"}>
                            <Dropdown
                              id="payment_method"
                              value={formData?.payment_method?.id ?? formData?.paymentMethod}
                              options={window.App.sortDropdownOptions(paymentMethods, "name")}
                              optionLabel="name"
                              optionValue="id"
                              placeholder={t('selectPlaceholder')}
                              className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'payment_method')})}
                              onChange={(e) => {
                                const id = e.value ? Number(e.value) : null;
                                const selected = paymentMethods.find(pm => pm.id === id);
                                input.onChange(id);
                                setFormData(prev => ({
                                  ...prev,
                                  payment_method: selected ? selected : { id: null }, 
                                  paymentMethod: id,
                                  isPaid: selected?.paid ?? null
                                }));
                                setPaymentMethodIsPaid(selected?.paid ?? null);
                                if (selected) {
                                  localStorage.setItem('defaultPaymentMethodId', String(selected.id));
                                  localStorage.setItem('defaultPaymentMethodName', selected.name);
                                }
                              }}
                            />
                          </span>
                        {getFormErrorMessage(meta, submitFailed, 'payment_method')}
                      </div>
                    )}/>
                  </div>
                </div>
              </Panel>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Panel headerTemplate={
                    <div className={"p-grid"}>
                      <div className={"p-col-12"}>
                        <h3>
                          <i className={"pi pi-list"}></i> {t('items')}
                        </h3>
                      </div>
                    </div>
                  } className={"p-mt-3"}>
                    {formData.items && formData.items[0] &&
                      <DataTable size={localStorage.getItem('scale')} value={formData.items}
                                 emptyMessage={t('noResults')}
                                 autoLayout={true}
                                 responsiveLayout="scroll"
                                 stripedRows
                                 className={"p-mb-3"}
                      >
                        <Column field="description" header={t('columnDescription')}></Column>
                        <Column field="quantity" header={t('columnQuantity')} className={"p-text-right"} alignHeader="right"
                                body={(rowData) => {
                                  return (
                                    <>
                                      {rowData.quantity} {rowData.unit?.name}
                                    </>
                                  )
                                }}></Column>
                        {formData.receipt_type !== 'delivery_note' &&
                          <Column field="unit_price" header={t('columnUnitPrice')} className={"p-text-right p-text-nowrap"}
                                  alignHeader="right"
                                  body={(rowData) => {
                                    const val = rowData.unitPrice 
                                              ?? rowData.unit_price 
                                              ?? 0;
                                    return priceFormatter(val);
                                  }}></Column>
                        }
                        {formData.receipt_type !== 'delivery_note' &&
                          <Column field="net_amount" header={t('columnNetValue')} className={"p-text-right p-text-nowrap"}
                                  alignHeader="right"
                                  body={(rowData) => {
                                    const val = rowData.net_amount 
                                              ?? rowData.net_amount
                                              ?? 0;
                                    return priceFormatter(val);
                                  }}></Column>
                        }
                        {formData.receipt_type !== 'delivery_note' &&
                          <Column header={t('fieldVat')} className='p-text-right' body={(rowData) => rowData.vat_rate?.label}></Column>
                        }
                        {formData.receipt_type !== 'delivery_note' &&
                          <Column field="grossAmount" header={t('columnGrossValue')} className={"p-text-right p-text-nowrap"}
                                  alignHeader="right"
                                  body={(rowData) => {
                                    const val = rowData.grossAmount 
                                              ?? rowData.gross_amount
                                              ?? 0;
                                    return priceFormatter(val);
                                  }}></Column>
                        }

                        <Column field="note" header={t('fieldNote')} className='p-text-right'></Column>

                            <Column body={itemActionBody} className={"p-text-right p-text-nowrap"}></Column>
                          </DataTable>
                        }
                        <div className={"p-grid p-mt-1"}>
                          <div className={"p-col-12 p-lg-6 p-xl-6"}>
                          </div>
                          <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                            <Button type="button" label={t('addReceiptItem')} icon="pi pi-plus" className="p-button-success"
                              loading={loading}
                              onClick={() => {
                                  setLoading(true);
                                  setServerErrors({});
                                  if (localStorage.getItem("defaultIsUnitPriceBr") === null) {
                                      localStorage.setItem('defaultIsUnitPriceBr', false)
                                  }
                                  setItemFormData({
                                    description: '',
                                    product: null,
                                    unit: null,
                                    vat: null,
                                    is_unit_price_gr: JSON.parse(localStorage.getItem("defaultIsUnitPriceBr")) || false,
                                    quantity: 1,
                                    unit_price: 0
                                  });
                                  axios({
                                    method: 'get',
                                    url: process.env.REACT_APP_API_HOST + '/api/v2/network/settings',
                                    headers: {
                                      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                      'App-Network': localStorage.getItem("networkId")
                                    }
                                  })
                                    .then(response => {
                                      const settings = response?.data?.data || {};
                                      const defaultUnit = getId(settings?.default_unit);
                                      const defaultVatRate = getId(settings?.default_vat_rate);
                                      setItemFormData(prev => ({
                                        ...prev,
                                        ...(defaultUnit ? { unit: defaultUnit } : {}),
                                        ...(defaultVatRate ? { vat: defaultVatRate } : {})
                                      }));
                                    })
                                    .catch(error => {
                                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                    });
                                  setSelectedItemCosttype('')
                                  setSelectedItemProject('')
                                  setSelectedItemTechnology('')
                                  const headers = {
                                      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                      'App-Network': localStorage.getItem("networkId")
                                  };
                                  const apiHost = process.env.REACT_APP_API_HOST;
                                  const getId = (val) => {
                                    if (val === null || val === undefined) return null;
                                    if (Array.isArray(val)) return null;

                                    if (typeof val === 'object') {
                                      if (val.id !== undefined && val.id !== null && String(val.id).trim() !== '') return Number(val.id);
                                      return null;
                                    }

                                    if (typeof val === 'string' && val.trim() === '') return null;

                                    const num = Number(val);
                                    return Number.isFinite(num) ? num : null;
                                  };

                                  let rgId = getId(formData.receipt_group) || getId(formData.receiptGroup);
                                  if (!rgId && window.App.state.props?.receiptgroupId) rgId = window.App.state.props.receiptgroupId;
                                  if (!rgId && props.initialValues?.receiptGroup?.id) rgId = props.initialValues.receiptGroup.id;

                                  if (!rgId) {
                                      console.error("HIBA: Receipt Group ID nem található!", formData);
                                      window.App.toastShow('error', 'Hiba', 'Nem található a bizonylattömb azonosítója.');
                                      setLoading(false);
                                      return;
                                  }
                                  const isExternal = external;
                                  const isOutgoing = outgoing;
                                  const payload = {
                                    company: getId(formData.company),
                                    partner: getId(formData.partner),

                                    delivery_date: formData.delivery_date,
                                    payment_date: formData.payment_date,

                                    currency: formData.currency || 'HUF',
                                    ...billingFields(formData),
                                    exchange_rate: formData.exchange_rate ?? formData.exchangeRate ?? null,
                                    payment_method:
                                      getId(formData.paymentMethod) ||
                                      getId(formData.payment_method) ||
                                      Number(localStorage.getItem('defaultPaymentMethodId')) ||
                                      2,

                                    locale: (formData.language || formData.locale || 'hu').toLowerCase(),
                                    language: (formData.language || formData.locale || 'hu').toLowerCase(),
                                    note: formData.note ?? "",
                                    file: (uploadedFile?.id ?? formData?.file?.id ?? formData?.file) || null,

                                    external: isExternal,
                                    outgoing: isOutgoing,

                                    receipt_type: resolveReceiptType({ outgoing: isOutgoing, receiptType: window.App.state.props?.receiptType }),

                                    items: []
                                  };
                                  const mustSendReceiptNumber = (isOutgoing === false) || (isOutgoing === true && isExternal === true);
                                  if (isExternal === true) {
                                    payload.issue_date = formData.issue_date;
                                    payload.issue_date = formData.issue_date;

                                    payload.receipt_number = String(formData.receipt_number || '').trim();
                                    payload.receipt_number  = payload.receipt_number;

                                    if (!payload.receipt_number) {
                                      setServerErrors(prev => ({
                                        ...prev,
                                        receipt_number: 'Ez az érték nem lehet üres.'
                                      }));
                                      window.App.toastShow('warn', 'Hiányzó adat', 'Sorszám megadása kötelező tétel rögzítéséhez.');
                                      setLoading(false);
                                      return;
                                    }
                                  }

                                  if (mustSendReceiptNumber) {
                                    payload.issue_date = formData.issue_date;
                                    payload.receipt_number = String(formData.receipt_number || '').trim();

                                    if (!payload.receipt_number) {
                                      setServerErrors(prev => ({ ...prev, receipt_number: 'Ez az érték nem lehet üres.' }));
                                      setLoading(false);
                                      return;
                                    }
                                  }

                                const receiptTypeUi = window.App.state.props?.receiptType;
                                payload.receipt_type = resolveReceiptType({
                                  outgoing: isOutgoing,
                                  receiptType: receiptTypeUi
                                });

                                if (!formData.id) {
                                    const url = `${apiHost}/api/v2/receipt/${rgId}`;

                                    axios({ method: 'post', url: url, data: payload, headers: headers })
                                    .then(response => {
                                        const receipt = response.data?.data || response.data;
                                        setItemDialog(true);
                                        setItemFormMethod('create');
                                        // setFormData(receipt);
                                        setFormData(prev => ({
                                          ...receipt,
                                          exchangeRate: receipt?.exchange_rate ?? prev?.exchangeRate ?? prev?.exchange_rate ?? null
                                        }));
                                        const fid = receipt?.file?.id ?? receipt?.file ?? null;
                                        if (fid) {
                                          downloadFileAsBlobUrl(Number(fid));
                                        } else {
                                          setFileBlobUrl((prev) => {
                                            revokeFileUrl(prev);
                                            return null;
                                          });
                                        }
                                        setLoading(false);
                                    })
                                    .catch(error => {
                                        setLoading(false);
                                        const mapped = mapBackend400ToFormErrors(error);
                                        if (mapped) setServerErrors(mapped);
                                        console.error("POST Hiba:", error);
                                        window.App.toastShow('error', 'Hiba', null, 5000, error.response);
                                    })
                                } else {
                                    const url = `${apiHost}/api/v2/receipt/${rgId}/${formData.id}`;
                                    // axios({ method: 'put', url: url, data: payload, headers: headers })
                                    axios({ method: 'patch', url: url, data: payload, headers: headers })
                                    .then(response => {
                                        const receipt = response.data?.data || response.data;
                                        if (file !== false) {
                                            ReceiptFileUploadService(file, receipt.id).catch(console.error);
                                        }
                                        setItemDialog(true);
                                        setItemFormMethod('create');
                                        // setFormData(receipt);
                                        setFormData(prev => ({
                                          ...prev,
                                          ...receipt,

                                          exchange_rate:
                                            receipt?.exchange_rate ??
                                            receipt?.exchangeRate ??
                                            prev?.exchange_rate ??
                                            prev?.exchangeRate ??
                                            null,
                                        }));
                                        const fid = receipt?.file?.id ?? receipt?.file ?? null;
                                        if (fid) {
                                          setUploadedFile(typeof receipt.file === 'object' ? receipt.file : { id: Number(fid) });
                                          fetchReceiptFileBlobUrl(Number(fid)).catch(console.error);
                                        }
                                        setLoading(false);
                                    })
                                    .catch(error => {
                                        setLoading(false);
                                        const mapped = mapBackend400ToFormErrors(error);
                                        if (mapped) setServerErrors(mapped);
                                        console.error("PUT Hiba:", error);
                                        window.App.toastShow('error', 'Hiba történt!', error.response?.data?.detail || "Hiba a bizonylat frissítésekor");
                                    })
                                }
                            }}
                        />
                      </div>
                    </div>
                    {window.App.state.props.receiptType !== 'delivery_note' &&
                      <>
                        <div className={"p-grid p-mt-1"}>
                          <div className={"p-col"}>
                          </div>
                          {/* <div className={"p-col p-text-right"}>
                            {window.App.state.props && window.App.state.props.external === true ? (
                              <>
                                <table align="right">
                                  <tr>
                                    <td className={"p-text-nowrap p-text-right"}>{t('netTotalAmount')}:</td>
                                    <td>
                                      {formData && formData.currency ? (
                                        <InputNumber id="net_amount"
                                                     minFractionDigits={0}
                                                     maxFractionDigits={9}
                                                     locale="hu-HU"
                                                     value={formData.net_amount}
                                                     onChange={(e) => {
                                                       setFormData({
                                                         ...formData,
                                                         net_amount: Number(e.value),
                                                       })
                                                       setIsSummaryOverwritten(true)
                                                     }}
                                        />
                                      ) : (
                                        <InputNumber id="net_amount"
                                                     locale="hu-HU"
                                                     minFractionDigits={0}
                                                     maxFractionDigits={9}
                                                     onChange={(e) => {
                                                       setFormData({
                                                         ...formData,
                                                         net_amount: Number(e.value)
                                                       })
                                                       setIsSummaryOverwritten(true)
                                                     }}
                                                     value={formData.net_amount}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className={"p-text-nowrap p-text-right"}>{t('vatAbbreviation')} tartalom:</td>
                                    <td>
                                      {formData && formData.currency ? (
                                        <InputNumber id="vat_amount"
                                                     minFractionDigits={0}
                                                     maxFractionDigits={9}
                                                     locale="hu-HU"
                                                     value={formData.vat_amount}
                                                     onChange={(e) => {
                                                       setFormData({
                                                         ...formData,
                                                         vat_amount: e.value,
                                                       })
                                                       setItemFormData({
                                                         ...itemFormData,
                                                         isSummaryOverwritten: true,
                                                       })
                                                     }}
                                        />
                                      ) : (
                                        <InputNumber id="vat_amount"
                                                     locale="hu-HU"
                                                     minFractionDigits={0}
                                                     maxFractionDigits={9}
                                                     onChange={(e) => {
                                                       setFormData({
                                                         ...formData,
                                                         vat_amount: e.value
                                                       })
                                                       setItemFormData({
                                                         ...itemFormData,
                                                         isSummaryOverwritten: true,
                                                       })
                                                     }}
                                                     value={formData.vat_amount}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className={"p-text-nowrap p-text-right"}>{t('grossTotalAmount')}:</td>
                                    <td>
                                      {formData && formData.currency ? (
                                        <InputNumber id="gross_amount"
                                                     minFractionDigits={0}
                                                     maxFractionDigits={9}
                                                     locale="hu-HU"
                                                     value={formData.gross_amount}
                                                     onChange={(e) => {
                                                       setFormData({
                                                         ...formData,
                                                         gross_amount: Number(e.value),
                                                       })
                                                       setIsSummaryOverwritten(true)
                                                     }}
                                        />
                                      ) : (
                                        <InputNumber id="gross_amount"
                                                     locale="hu-HU"
                                                     minFractionDigits={0}
                                                     maxFractionDigits={9}
                                                     onChange={(e) => {
                                                       setFormData({
                                                         ...formData,
                                                         gross_amount: Number(e.value)
                                                       })
                                                       setIsSummaryOverwritten(true)
                                                     }}
                                                     value={formData.gross_amount}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                </table>
                              </>
                            ) : (
                              <> */}
                                <table align="right">
                                  <tr>
                                    <td>{t('netTotalAmount')}:</td>
                                    <td className="p-text-right  p-text-nowrap"><span className="p-text-bold">
                                      {formatCurrency(formData.currency, formData.net_amount)}
                                    </span></td>
                                  </tr>
                                  <tr>
                                    <td>{t('vatAbbreviation')} tartalom:</td>
                                    <td className="p-text-right  p-text-nowrap"><span className="p-text-bold">
                                      {formatCurrency(formData.currency, formData.vat_amount)}
                                    </span></td>
                                  </tr>
                                  <tr>
                                    <td>{t('grossTotalAmount')}:</td>
                                    <td className="p-text-right  p-text-nowrap"><span className="p-text-bold">
                                      {formatCurrency(formData.currency, formData.gross_amount)}
                                    </span></td>
                                  </tr>
                                </table>
                              {/* </>
                            )}
                          </div> */}
                        </div>
                      </>
                    }
                  </Panel>










                    <Panel headerTemplate={
                        <div className={"p-grid"}>
                        <div className={"p-col-12"}>
                            <h3>
                            <i className={"pi pi-cog"}></i> {t('additionalSettings')}
                            </h3>
                        </div>
                        </div>
                    } className={"p-mt-3"}>
                        <div className={"p-grid"}>
                  <ReceiptBillingFields data={formData} external={external} receiptType={resolveReceiptType({outgoing, receiptType: formData.receiptType || formData.receipt_type || window.App.state.props?.receiptType})} section="period" onChange={patch => {
                    patch = withSettlementPeriodNote(formData, patch, periodNoteState.current);
                    setFormData(prev => ({...prev, ...patch}));
                    Object.entries(patch).forEach(([key, value]) => form.change(key, value));
                  }}/>
                  <ReceiptBillingFields data={formData} external={external} receiptType={resolveReceiptType({outgoing, receiptType: formData.receiptType || formData.receipt_type || window.App.state.props?.receiptType})} section="rate" onChange={patch => {
                    setFormData(prev => ({...prev, ...patch}));
                    Object.entries(patch).forEach(([key, value]) => form.change(key, value));
                  }}/>
                        {uiOutgoing !== false && <>
                        <div className={"p-col-12 p-lg-6 p-xl-6"}>
                            <Field name="company_bank_account" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                                <label htmlFor="company_bank_account"
                                    className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'company_bank_account')})}>{props.t('fieldCompanyBankAccount')}</label>
                                <span className="p-d-block">
                                <Dropdown {...input}
                                        value={
                                          input.value?.id ||
                                          input.value ||
                                          formData.company_bank_account?.id ||
                                          formData.companyBankAccount?.id ||
                                          null
                                        }
                                        options={window.App.sortDropdownOptions(bankAccounts, "name")}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"companyBankAccount"}
                                        onChange={(e) => {
                                          const selectedId = e.value ? Number(e.value) : null;
                                          const selectedAcc = bankAccounts.find(acc => Number(acc.id) === selectedId) || null;
                                          setFormData(prev => ({
                                            ...prev,
                                            companyBankAccount: selectedId ? { id: selectedId } : null,
                                            company_bank_account: selectedAcc,
                                            company_bank_account_number: selectedAcc?.bankaccount || selectedAcc?.account_number || '',
                                            companyIBAN: selectedAcc?.iban || '',
                                            companySwift: selectedAcc?.swift || ''
                                          }));
                                          input.onChange(selectedId);
                                        }}
                                        emptyMessage={t('noBankAccountYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'company_bank_account')})}
                                />
                                </span>
                                {getFormErrorMessage(meta, submitFailed, 'company_bank_account')}
                            </div>
                            )}/>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-xl-6"}>
                            <Field name="language" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                                <label htmlFor="language"
                                    className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'language')})}>{props.t('fieldLanguage')}</label>
                                <span className="p-d-block">
                                <Dropdown
                                    options={window.App.sortDropdownOptions(languages, "name")}
                                    id={"language"}
                                    optionLabel="name"
                                    optionValue="code"
                                    onChange={(e) => {
                                    const patch = withSettlementPeriodNote(formData, {language: e.value}, periodNoteState.current);
                                    setFormData(prev => ({...prev, ...patch}));
                                    Object.entries(patch).forEach(([key, value]) => form.change(key, value));
                                    }}
                                    value={formData.language}
                                />
                                </span>
                            </div>
                            )}/>
                        </div>
                        </>}
                        </div>
                    </Panel>
                  <Panel headerTemplate={
                    <div className={"p-grid"}>
                      <div className={"p-col-12"}>
                        <h3>
                          <i className={"pi pi-list"}></i> {t('comment')}
                        </h3>
                      </div>
                    </div>
                  } className={"p-mt-3"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-12 p-xl-12"}>
                        <Field name="note" render={({input, meta}) => (
                          <div className="p-field p-fluid">
                    <span className={"p-d-block"}>
                    <InputTextarea id="note" {...input}
                               onChange={(e) => {
                                 periodNoteState.current.edited = true;
                                 input.onChange(e);
                                 setFormData({
                                   ...formData,
                                   note: e.target.value
                                 })
                               }}
                               value={formData.note}
                               className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'note')})}/>
                    </span>
                            {getFormErrorMessage(meta, submitFailed, 'note')}
                          </div>
                        )}/>
                      </div>
                    </div>
                  </Panel>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <div className={"p-grid p-mt-1"}>
                    <div className={"p-col-12"}>
                      <h3 className={"p-mb-2"}>
                        {((window.App.state.props && window.App.state.props.external === true) || formData.external === true) ? (
                          <><i className={"pi pi-file"}></i> {t('receiptImage')}</>
                        ) : (
                          <><i className={"pi pi-file"}></i> {t('preview')}</>
                        )}
                      </h3>
                    </div>
                  </div>
                  {((window.App.state.props && window.App.state.props.external === true) || formData.external === true) ? (
                    <div className={"p-grid"}>
                      {process.env.REACT_APP_BRAND !== 'trackie' || localStorage.getItem('networkId') === '8'
                      || localStorage.getItem('networkId') === '1' ? (
                        <>
                          <div className={"p-col-12"}>
                            <Field name="image" render={({input, meta}) => {
                              const fileId = formData?.file?.id ?? formData?.file ?? null;
                              const hasFile = !!fileId;
                              return (
                                <div className="p-field">
                                  {fileUploadError && (
                                    <small className="p-error p-d-block p-mb-2">{fileUploadError}</small>
                                  )}
                                  {!hasFile ? (
                                    <>
                                      <label htmlFor="file" className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'image')})}>{props.t('fieldImageOrPdfUpload')}</label>
                                      <FileUpload
                                        className="receipt-upload"
                                        ref={fileUploadRef}
                                        name="file"
                                        mode="advanced"
                                        auto={false}
                                        customUpload
                                        uploadHandler={uploadReceiptFileNow}
                                        accept="application/pdf,image/*"
                                        chooseLabel={selectedLocalFile?.name || t('chooseFile')}
                                        uploadLabel={t('upload')}
                                        cancelLabel={t('cancel')}
                                        onSelect={(e) => {
                                          const f = e.files?.[0] || null;
                                          setSelectedLocalFile(f);
                                          setFileUploadError(null);
                                        }}
                                        onClear={() => setSelectedLocalFile(null)}
                                        onRemove={() => setSelectedLocalFile(null)}
                                        disabled={fileUploading || loading}
                                      />
                                      {fileUploading && (
                                        <div className="p-mt-2">
                                          <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
                                        </div>
                                      )}
                                      <div
                                        style={{
                                          marginTop: '35rem',
                                          display: 'flex',
                                          justifyContent: 'flex-end',
                                          alignItems: 'center',
                                          gap: '0.5rem',
                                          flexWrap: 'nowrap',
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        {actionButtons}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {fileBlobUrl ? (
                                        <ReceiptPdfViewerComponent file={fileBlobUrl} height={987} />
                                      ) : (
                                        <span className={"p-d-block p-py-4"} style={{fontSize: '1.2em'}}>
                                          <i className="pi pi-spin pi-spinner" style={{fontSize: '0.9em'}}></i>
                                          &nbsp;Betöltés...
                                        </span>
                                      )}
                                      <div
                                        style={{
                                          marginTop: '0rem',
                                          display: 'flex',
                                          justifyContent: 'flex-end',
                                          alignItems: 'center',
                                          gap: '0.5rem',
                                          flexWrap: 'nowrap',
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        {actionButtons}
                                      </div>
                                      <label className="p-d-block p-mt-3">{props.t('fieldRemoveUploadedFile')}</label>
                                      <Button
                                        type="button"
                                        label={t('delete')}
                                        icon="pi pi-trash"
                                        className="p-button-danger"
                                        onClick={() => {
                                          if (!window.confirm('A törlés megerősítésére van szükség!')) return;
                                          const rgId = getSafeReceiptGroupId(formData);
                                          const receiptId = formData?.id;
                                          if (!rgId || !receiptId) {
                                            window.App.toastShow('error', 'Hiba', 'Hiányzó bizonylattömb vagy bizonylat azonosító.');
                                            return;
                                          }
                                          setLoading(true);
                                          patchReceiptFile(rgId, receiptId, null)
                                            .then(() => {
                                              window.App.toastShow('success', 'Sikeres törlés!', 'A fájl leválasztásra került a bizonylatról.');
                                              revokeFileUrl(fileBlobUrl);
                                              setFileBlobUrl(null);
                                              setUploadedFile(null);
                                              setSelectedLocalFile(null);
                                              setFormData((prev) => ({ ...prev, file: null }));
                                            })
                                            .catch((error) => {
                                              window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                            })
                                            .finally(() => setLoading(false));
                                        }}
                                      />
                                    </>
                                  )}
                                  {getFormErrorMessage(meta, submitFailed, 'image')}
                                </div>
                              );
                            }} 
                            />
                          </div>
                        </>
                      ) : (
                        <div className={"p-col"}>
                          <i className={"pi pi-lock"}></i>&nbsp; {t('receiptImage')} feltöltése csak privát felhő előfizetés
                          esetén lehetséges! Kérjük vedd fel velünk a kapcsolatot a <a
                          href={"mailto:hello@trackie.io"}>hello@trackie.io</a> email címen!
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      {/* {formData.companyName && formData.partnerName ? ( */}
                      {(formData.companyName && formData.partnerName) || (Array.isArray(formData?.items) && formData.items.length > 0) ? (
                        <div style={{maxWidth: '25cm', borderRadius: '0', margin: 'auto'}}>
                          <Panel className={"p-mx-auto p-p-5"}
                                 style={{maxWidth: '25cm'}}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12 p-lg-6"}>

                              </div>
                              <div className={"p-col-12 p-lg-6"}>
                                <h1 className={"p-m-0 p-p-0 p-text-uppercase p-text-right p-text-normal"}>
                                  {formData.receipt_type === 'invoice' && formData.outgoing === true &&
                                    <>{t('receiptInvoice')}</>
                                  }
                                  {formData.receipt_type === 'invoice' && formData.outgoing === false &&
                                    <>{t('receiptCostInvoice')}</>
                                  }
                                  {formData.receipt_type === 'delivery_note' &&
                                    <>{t('receiptDeliveryNote')}</>
                                  }
                                </h1>
                              </div>
                            </div>
                            <div className={"p-grid p-mt-1"}>
                              <div className={"p-col"}>
                                <label>
                                  {formData.receipt_type === 'delivery_note' ? (
                                    <>
                                      {t('deliveryNoteIssueDate')}
                                    </>
                                  ) : (
                                    <>
                                      {t('receiptInvoice')} kelte
                                    </>
                                  )}
                                </label>
                                <strong className={"p-d-block"}>
                                  {/* {moment.utc(formData.issue_date).local().format('YYYY.MM.DD.')} */}
                                  {formData.issue_date
                                    ? moment.utc(formData.issue_date).local().format('YYYY.MM.DD.')
                                    : ''
                                  }
                                </strong>
                              </div>
                              <div className={"p-col"}>
                                <label>{props.t('fieldDeliveryDate')}</label>
                                <strong className={"p-d-block"}>
                                  {formData.delivery_date && formData.delivery_date !== null &&
                                    <>
                                      {moment.utc(formData.delivery_date).local().format('YYYY.MM.DD.')}
                                    </>
                                  }
                                </strong>
                              </div>
                              {formData.receipt_type !== 'delivery_note' &&
                                <div className={"p-col"}>
                                  <label>{props.t('fieldPaymentDate')}</label>
                                  <strong className={"p-d-block"}>
                                    {moment.utc(formData.payment_date).local().format('YYYY.MM.DD.')}
                                  </strong>
                                </div>
                              }
                              {formData.receipt_type !== 'delivery_note' &&
                                <div className={"p-col"}>
                                  <label>{props.t('fieldPaymentMode')}</label>
                                  <strong className={"p-d-block"}>
                                    {formData.payment_method?.name}
                                  </strong>
                                </div>
                              }
                              <div className={"p-col p-text-right"}>
                                <label>
                                  {formData.receipt_type === 'delivery_note' ? (
                                    <>
                                      {t('deliveryNoteNumber')}
                                    </>
                                  ) : (
                                    <>
                                      {t('receiptInvoice')} sorszáma
                                    </>
                                  )}
                                </label>
                                <strong className={"p-d-block"}>
                                  {formData.receipt_number}
                                </strong>
                              </div>
                            </div>
                            <div className={"p-grid p-mt-1"}>
                              <div className={"p-col"}>
                                <label>
                                  {formData.outgoing === true &&
                                    <>{t('supplierLabel')}</>
                                  }
                                  {formData.outgoing === false &&
                                    <>{t('customerLabel')}</>
                                  }
                                </label>
                                <h3 className={"p-m-0 p-p-0"}>
                                  {formData.company_name}
                                </h3>
                                {formData.company_address_postal_code}&nbsp;{formData.company_address_city}
                                <br/>
                                {formData.company_address_detail}
                                <br/>
                                {t('taxNumber')}: {formData.company_vat_number}
                                {formData.company_community_vat_number && formData.company_community_vat_number !== null &&
                                  <>
                                    <br/>
                                    {t('communityVatNumber')}: {formData.company_community_vat_number}
                                  </>
                                }
                                {(() => {
                                  const selectedAccId = formData.companyBankAccount?.id || formData.company_bank_account?.id;
                                  const selectedAcc = bankAccounts.find(acc => acc.id === Number(selectedAccId));
                                  const preferIban = formData.currency !== 'HUF';
                                  const iban = selectedAcc?.iban || formData.companyIBAN;
                                  const accountNumber = selectedAcc?.bankaccount || selectedAcc?.account_number || formData.company_bank_account_number;
                                  const swift = selectedAcc?.swift || formData.companySwift;
                                  if (!iban && !accountNumber && !swift) return null;
                                  return (
                                    <>
                                      {preferIban && iban ? (
                                        <>
                                          <br />
                                          IBAN: {iban}
                                        </>
                                      ) : accountNumber ? (
                                        <>
                                          <br />
                                          {t('accountNumber')}: {accountNumber}
                                        </>
                                      ) : null}
                                      {swift && (
                                        <>
                                          <br />
                                          Swift: {swift}
                                        </>
                                      )}
                                    </>
                                  );
                                })()}
                              </div>
                              <div className={"p-col"}>
                                <label>
                                  {formData.outgoing === true &&
                                    <>{t('customerLabel')}</>
                                  }
                                  {formData.outgoing === false &&
                                    <>{t('supplierLabel')}</>
                                  }
                                </label>
                                <h3 className={"p-m-0 p-p-0"}>
                                  {formData.partner_name}
                                </h3>
                                {formData.partnerShippingAddress ? (
                                  <>
                                    {t('shippingAddress')}:&nbsp;
                                    {shippingAddress.addressPostalCode}&nbsp;{shippingAddress.addressCity}
                                    <br/>
                                    {shippingAddress.addressDetail}
                                  </>
                                ) : (
                                  <>
                                    {formData.partner_address_postal_code}&nbsp;{formData.partner_address_city}
                                    <br/>
                                    {formData.partner_address_detail}
                                  </>
                                )}
                                {formData.partner_vat_number && formData.partner_vat_number !== null &&
                                  <>
                                    <br/>
                                    {t('taxNumber')}: {formData.partner_vat_number}
                                  </>
                                }
                                {formData.partner_community_vat_number && formData.partner_community_vat_number !== null &&
                                  <>
                                    <br/>
                                    {t('communityVatNumber')}: {formData.partner_community_vat_number}
                                  </>
                                }
                                {formData.partnerGroupVatNumber && formData.partnerGroupVatNumber !== null &&
                                  <>
                                    <br/>
                                    Csoportos adószám: {formData.partnerGroupVatNumber}
                                  </>
                                }
                              </div>
                            </div>
                            {formData.receipt_type !== 'delivery_note' ? (
                              <table className={"p-mt-3 w-100"} cellPadding={'5px'} cellSpacing={0}>
                                <tr>
                                  <th className={"p-text-normal p-text-uppercase p-text-left"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('columnName')}
                                  </th>
                                  <th className={"p-text-normal p-text-uppercase p-text-right"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('columnQuantity')}
                                  </th>
                                  <th className={"p-text-normal p-text-uppercase p-text-right"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('columnNetUnitPrice')}
                                  </th>
                                  <th className={"p-text-normal p-text-uppercase p-text-right"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('vatAbbreviation')}
                                  </th>
                                  <th className={"p-text-normal p-text-uppercase p-text-right"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('columnNetValue')}
                                  </th>
                                  <th className={"p-text-normal p-text-uppercase p-text-right"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('columnVatValue')}
                                  </th>
                                  <th className={"p-text-normal p-text-uppercase p-text-right"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('grossValue')}
                                  </th>
                                </tr>
                                {formData.items && formData.items[0] ? (
                                  [formData.items.map((item, index) => {
                                    return (
                                      <>
                                        <tr>
                                          <td colSpan={7}>
                                            <strong>
                                              {item.description}
                                            </strong>
                                            {item.note && (
                                              <div style={{fontSize: '13px', color: '#666', whiteSpace: 'pre-wrap'}}>
                                                {t('comment')}: {item.note}
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            &nbsp;
                                          </td>
                                          <td className={"p-text-right"}>
                                            {item.quantity}&nbsp;{item.unit?.name}
                                          </td>
                                          <td className={"p-text-right"}>
                                            {priceFormatter(item.is_unit_price_gr
                                              ? item.unit_price / (1 + Number(item.vat_rate?.percentage ?? 0) / 100)
                                              : item.unit_price)}
                                          </td>
                                          <td className={"p-text-center"}>
                                            {itemVatBody(item)}
                                          </td>
                                          <td className={"p-text-right"}>
                                            {priceFormatter(item.net_amount)}
                                          </td>
                                          <td className={"p-text-right"}>
                                            {priceFormatter(item.vat_amount)}
                                          </td>
                                          <td className={"p-text-right"}>
                                            {priceFormatter(item.gross_amount)}
                                          </td>
                                        </tr>
                                      </>
                                    )
                                  })]
                                ) : (
                                  <tr>
                                    <td colSpan={7}>
                                      <small>{props.t('noItemRecorded')}</small>
                                    </td>
                                  </tr>
                                )}
                                <tr>
                                  <th colSpan={4} className={"p-text-left"} style={{borderTop: '1px solid #ccc'}}>
                                    <strong>
                                      {t('total')}
                                    </strong>
                                  </th>
                                  <th className={"p-text-right"} style={{borderTop: '1px solid #ccc'}}>
                                    <strong>
                                      {priceFormatter(formData.net_amount)}
                                    </strong>
                                  </th>
                                  <th className={"p-text-right"} style={{borderTop: '1px solid #ccc'}}>
                                    <strong>
                                      {priceFormatter(formData.vat_amount)}
                                    </strong>
                                  </th>
                                  <th className={"p-text-right"} style={{borderTop: '1px solid #ccc'}}>
                                    <strong>
                                      {priceFormatter(formData.gross_amount)}
                                    </strong>
                                  </th>
                                </tr>
                              </table>
                            ) : (
                              <table className={"p-mt-3 w-100"} cellPadding={'5px'} cellSpacing={0}>
                                <tr>
                                  <th className={"p-text-normal p-text-uppercase p-text-left"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('items')}
                                  </th>
                                  <th className={"p-text-normal p-text-uppercase p-text-right"}
                                      style={{borderBottom: '1px solid #ccc'}}>
                                    {t('columnQuantity')}
                                  </th>
                                </tr>
                                {formData.items && formData.items[0] ? (
                                  [formData.items.map((item, index) => {
                                    return (
                                      <>
                                        <tr>
                                          <td>
                                            <strong>
                                              {item.description}
                                            </strong>
                                          </td>
                                          <td className={"p-text-right"}>
                                            {item.quantity}&nbsp;{item.unitName}
                                          </td>
                                        </tr>
                                      </>
                                    )
                                  })]
                                ) : (
                                  <tr>
                                    <td colSpan={7}>
                                      <small>{props.t('noItemRecorded')}</small>
                                    </td>
                                  </tr>
                                )}
                              </table>
                            )}
                            {formData.note && (
                              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                <br/>
                                {formData.note}
                              </div>
                            )}
                            <div className={"p-grid p-mt-1"}>
                              {formData.projectSummary && formData.projectSummary[0] &&
                                <div className={"p-col"}>
                                  <table className={"w-100"}>
                                    <tr>
                                      <th className={"p-text-normal p-text-uppercase p-text-left"}
                                          style={{borderBottom: '1px solid #ccc'}}>
                                        {t('project')}
                                      </th>
                                      <th className={"p-text-normal p-text-uppercase p-text-right"}
                                          style={{borderBottom: '1px solid #ccc'}}>
                                        {t('total')}
                                      </th>
                                    </tr>
                                    {formData.projectSummary && formData.projectSummary[0] &&
                                      [formData.projectSummary.map((item, index) => {
                                        return (
                                          <>
                                            <tr>
                                              <td>
                                                {item.projectName}
                                              </td>
                                              <td className={"p-text-right p-text-nowrap"}>
                                                {priceFormatter(item.totalNetAmount)}
                                              </td>
                                            </tr>
                                          </>
                                        )
                                      })]
                                    }
                                  </table>
                                </div>
                              }
                              {formData.costTypeSummary && formData.costTypeSummary[0] &&
                                <div className={"p-col"}>
                                  <table className={"w-100"}>
                                    <tr>
                                      <th className={"p-text-normal p-text-uppercase p-text-left"}
                                          style={{borderBottom: '1px solid #ccc'}}>
                                        {t('columnCostType')}
                                      </th>
                                      <th className={"p-text-normal p-text-uppercase p-text-right"}
                                          style={{borderBottom: '1px solid #ccc'}}>
                                        {t('total')}
                                      </th>
                                    </tr>
                                    {formData.costTypeSummary && formData.costTypeSummary[0] &&
                                      [formData.costTypeSummary.map((item, index) => {
                                        return (
                                          <>
                                            <tr>
                                              <td>
                                                {item.costTypeName}
                                              </td>
                                              <td className={"p-text-right p-text-nowrap"}>
                                                {priceFormatter(item.totalNetAmount)}
                                              </td>
                                            </tr>
                                          </>
                                        )
                                      })]
                                    }
                                  </table>
                                </div>
                              }
                            </div>
                            {/* <p className={"p-mt-3"} style={{ whiteSpace: 'pre-wrap' }}>
                              <strong>
                                {t('comment')}:&nbsp;
                              </strong>
                              {formData.note}
                            </p> */}
                          </Panel>
                          {formData.id &&
                            <div className={"p-grid p-mt-1"}>
                              <div className={"p-col-12"}>
                                <Message className={"w-100"} severity="warn" text="Figyelem! Az előnézet nem egyezik meg teljesen a valós
                          nyomtatási képpel. A pontos nyomtatási kép letölthető már vázlat formában is!"></Message>
                              </div>
                              <div className={"p-col-12 p-lg-2 p-col-align-center"}>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  alignItems: 'center',
                                  gap: '0.5rem',
                                  flexWrap: 'nowrap',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {actionButtons}
                                {formData.outgoing === true &&
                                  <Button icon="pi pi-download" className="p-button p-ml-2"
                                          label={t('previewDownload')} type='button' loading={previewDownloading}
                                          onClick={async () => {
                                            setPreviewDownloading(true);
                                            try {
                                              const saveErrors = await onSubmit(values, form);
                                              if (saveErrors && Object.keys(saveErrors).length > 0) {
                                                setPreviewDownloading(false);
                                                return;
                                              }
                                              const response = await ReceiptDownloadPdfService(formData.id);
                                              window.App.toastShow('success', 'Sikeres letöltés!');
                                              download(
                                                response.data,
                                                receiptPdfFilename(formData)
                                              );
                                            } catch (error) {
                                              window.App.toastShow('error', t('toastError'), error.response?.data?.detail || error.response?.data?.message || error.toString(), '', error.response);
                                            } finally {
                                              setPreviewDownloading(false);
                                            }
                                          }}/>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      ) : (
                        <span className={"p-d-block p-p-4 p-text-center"} style={{fontSize: '1.5em'}}>
                    <i className="pi pi-spin pi-spinner" style={{fontSize: '0.9em'}}></i>
                          &nbsp;{t('previewInsufficientData')}
                    </span>
                      )}
                    </>
                  )}
                </div>
              </div>
              {!((window.App.state.props && window.App.state.props.external === true) || formData.external === true) && !formData.id && (
                <div className={"p-grid p-mt-1"}>
                  <div className={"p-col-12 p-lg-6 p-xl-6"}></div>

                  <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
                    {actionButtons}
                  </div>
                </div>
              )}


              <Dialog visible={itemDialog}
                      style={{width: '750px'}}
                      header={itemFormMethod === 'create' ? t('addItems') : t('updateItems')}
                      modal
                      onHide={() => {
                        const receiptId = formData?.id;
                        if (!receiptId) {
                          setItemDialog(false);
                          return;
                        }
                        setLoading(true);
                        const headers = {
                          Authorization: 'Bearer ' + localStorage.getItem('userToken'),
                          'App-Network': localStorage.getItem('networkId'),
                        };
                        axios
                          .get(`${process.env.REACT_APP_API_HOST}/api/v2/receipt/${Number(receiptId)}`, { headers })
                          .then((res) => {
                            const raw = res.data?.data || res.data;
                            const mapped = mapReceiptData(raw);
                            const nextPartnerName =
                              mapped?.partnerName ||
                              raw?.partner_name ||
                              raw?.partner?.name ||
                              '';
                            setPartnerDisplayValue(nextPartnerName);
                            setFormData((prev) => ({
                              ...prev,
                              ...mapped,
                              receiptgroupId:
                                prev?.receiptgroupId ??
                                raw?.receipt_group?.id ??
                                raw?.receipt_group ??
                                null,

                              exchangeRate:
                                raw?.exchange_rate ??
                                prev?.exchangeRate ??
                                prev?.exchange_rate ??
                                null,

                              exchange_rate:
                                raw?.exchange_rate ??
                                prev?.exchange_rate ??
                                prev?.exchangeRate ??
                                null,
                            }));
                          })
                          .catch((error) => {
                            window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                          })
                          .finally(() => {
                            setItemDialog(false);
                            setLoading(false);
                          });
                      }}>
                <Form onSubmit={itemOnSubmit}
                      initialValues={itemFormData}
                      validate={itemValidate}
                      render={({handleSubmit, values, form, submitFailed}) => (
                        <form onSubmit={handleSubmit} className="">
                          <div className={"p-grid"}>
                             <div className={"p-col-12"}>
                              <Field name="description" render={({input, meta}) => (
                                <div className="p-field p-fluid">
                                  <label htmlFor="description"
                                           className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'description')})}>{props.t('fieldItemName')}</label>
                                  <span className={"p-d-block"}>
                                    <InputText id="description" {...input}
                                               className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'description')})}/>
                                  </span>
                                  {getFormErrorMessage(meta, submitFailed, 'description')}
                                </div>
                              )}/>
                            </div>
                          </div>
                          <div className={"p-grid p-align-end"}>
                            <div className={"p-col-2"}>
                              <Field name="quantity" render={({input, meta}) => (
                                <div className="p-field p-fluid">
                                  <label htmlFor="quantity"
                                           className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'quantity')})}>{props.t('fieldQuantity')}</label>
                                  <span className={"p-d-block"}>
                                    <InputNumber id="quantity"
                                                 value={input.value}
                                                 onValueChange={(e) => input.onChange(e.value)}
                                                 onBlur={input.onBlur}
                                                 onFocus={input.onFocus}
                                                 minFractionDigits={0}
                                                 maxFractionDigits={4}
                                                 locale="hu-HU"
                                                 className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'quantity')})}/>
                                  </span>
                                  {getFormErrorMessage(meta, submitFailed, 'quantity')}
                                </div>
                              )}/>
                            </div>
                            <div className={"p-col-2"}>
                              <Field name="unit" render={({input, meta}) => (
                                <div className="p-field p-fluid">
                                  <label htmlFor="unit"
                                           className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'unit')})}>{props.t('fieldItemUnit')}</label>
                                  <span className={"p-d-block"}>
                                    <Dropdown {...input}
                                               onChange={(e) => {
                                                 input.onChange(e.value);
                                                 localStorage.setItem("defaultUnitId", e.value)
                                               }}
                                               value={input.value ?? null}
                                               options={window.App.sortDropdownOptions(units, "name")}
                                               optionLabel="name"
                                               optionValue="id"
                                               id={"unit"}
                                               placeholder={t('selectPlaceholder')}
                                               className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'unit')})}
                                    />
                                  </span>
                                  {getFormErrorMessage(meta, submitFailed, 'unit')}
                                </div>
                              )}/>
                            </div>
                            <div className={"p-col-3"}>
                                <Field name="unit_price" render={({input, meta}) => (
                                <div className="p-field p-fluid">
                                    <label htmlFor="unit_price" style={{textTransform: 'uppercase'}}>
                                        {values.is_unit_price_gr ? 'BR. EGYSÉGÁR' : 'NE. EGYSÉGÁR'}
                                    </label>
                                    <span className={"p-d-block"}>
                                    <InputNumber id="unit_price" 
                                                 value={input.value}
                                                 onValueChange={(e) => input.onChange(e.value)}
                                                 onBlur={input.onBlur}
                                                 onFocus={input.onFocus}
                                                 locale="hu-HU"
                                                 minFractionDigits={0}
                                                 maxFractionDigits={2}
                                                 className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'unit_price')})}/>
                                    </span>
                                    {getFormErrorMessage(meta, submitFailed, 'unit_price')}
                                </div>
                                )}/>
                            </div>
                            <div className={"p-col-1 p-d-flex p-ai-end p-pb-4"}>
                                <strong>{formData.currency || 'HUF'}</strong>
                            </div>
                            <div className={"p-col-2 p-text-center"}>
                                <div className="p-field">
                                    <label htmlFor="is_unit_price_gr" className="p-d-block p-mb-2">{props.t('fieldIsUnitPriceGr')}</label>
                                    <Field name="is_unit_price_gr">
                                      {({ input }) => (
                                        <InputSwitch
                                          checked={Boolean(input.value)}
                                          onChange={(e) => input.onChange(Boolean(e.value))}
                                        />
                                      )}
                                    </Field>
                                </div>
                            </div>
                            <div className={"p-col-2"}>
                              <Field name="vat" render={({input, meta}) => (
                                <div className="p-field p-fluid">
                                  <label htmlFor="vat"
                                           className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'vat')})}>{props.t('fieldVat')}</label>
                                  <span className={"p-d-block"}>
                                    <Dropdown {...input}
                                               onChange={(e) => {
                                                 input.onChange(e.value)
                                                 localStorage.setItem("defaultVatId", e.value)
                                               }}
                                               value={values.vat}
                                               options={window.App.sortDropdownOptions(vats, "label")}
                                               optionLabel="label"
                                               optionValue="id"
                                               id={"vat"}
                                               className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'vat')})}
                                    />
                                  </span>
                                  {getFormErrorMessage(meta, submitFailed, 'vat')}
                                </div>
                              )}/>
                            </div>
                          </div>
                          <div className={"p-grid"}>
                            {/* {localStorage.getItem('roles').toString().includes('role_product_read') &&
                              <div className={"p-col-12 p-lg-3 p-xl-3"}>
                                <Field name="product" render={({input, meta}) => (
                                  <div className="p-field p-fluid">
                                    <label htmlFor="product"
                                           className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'product')})}>{props.t('fieldProduct')}</label>
                                    <span className="p-inputgroup">
                                      <AutoComplete value={selectedProduct}
                                                    id={"product"}
                                                    suggestions={products}
                                                    forceSelection
                                                    completeMethod={searchProducts}
                                                    field={"name"}
                                                    delay="1000"
                                                    placeholder={t('typeToSearchPlaceholder')}
                                                    className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'product')})}
                                                    onSelect={(e) => {
                                                      setItemFormData({
                                                        ...itemFormData,
                                                        product: {id: e.value.id},
                                                        description: e.value.name
                                                      })
                                                    }}
                                                    onChange={(e) => {
                                                      setItemFormData({
                                                        ...itemFormData,
                                                        product: {id: null},
                                                        description: null
                                                      })
                                                      setSelectedProduct(e.value)
                                                    }}
                                                    onClear={(e) => {
                                                      setSelectedProduct('')
                                                    }}
                                      />
                                    </span>
                                    {getFormErrorMessage(meta, submitFailed, 'product')}
                                  </div>
                                )}/>
                              </div>
                            } */}

                            {/* <div className={"p-col"}>
                              <Field name="description" render={({input, meta}) => (
                                <div className="p-field p-fluid">
                                  <label htmlFor="description"
                                           className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'description')})}>{props.t('fieldName')}</label>
                                  <span className={"p-d-block"}>
                                    <InputText id="description" {...input}
                                               onChange={(e) => {
                                                 setItemFormData({
                                                   ...itemFormData,
                                                   description: e.target.value
                                                 })
                                               }}
                                               value={itemFormData.description}
                                               className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'description')})}/>
                                  </span>
                                  {getFormErrorMessage(meta, submitFailed, 'description')}
                                </div>
                              )}/>
                            </div>
                            */}
                          </div>

                          <div className={"p-grid p-mt-1"}>

                            {/*
                            {window.App.state.props && (window.App.state.props.receiptType === 'invoice'
                                || window.App.state.props.receiptType === 'fee_request') &&
                              <>
                                <div className={"p-col"}>
                                  <Field name="unitPriceOriginal" render={({input, meta}) => (
                                    <div className="p-field p-fluid">
                                      <label htmlFor="unitPriceOriginal"
                                             className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'unitPriceOriginal')})}>
                                        {itemFormData.isUnitPriceGr === true ? (
                                          <>Br.</>
                                        ) : (
                                          <>Ne.</>
                                        )}
                                        &nbsp;egységár</label>
                                      <span className={"p-d-block"}>
                                        <InputNumber id="unitPriceOriginal" {...input}
                                                     locale="hu-HU"
                                                     minFractionDigits={0}
                                                     maxFractionDigits={9}
                                                     onValueChange={(e) => {
                                                       setItemFormData({
                                                         ...itemFormData,
                                                         unitPriceOriginal: e.value
                                                       })
                                                     }}
                                                     value={itemFormData.unitPriceOriginal}
                                                     className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'unitPriceOriginal')})}/>
                                      </span>
                                      {getFormErrorMessage(meta, submitFailed, 'unitPriceOriginal')}
                                    </div>
                                  )}/>
                                </div>
                                <div className={"p-col-12 p-lg-1 p-xl-1"}>
                                  <div className="p-field">
                                    <label>&nbsp;</label>
                                    <span className="p-d-block p-pt-2">
                                      {formData.currency}
                                    </span>
                                  </div>
                                </div>
                              </>
                            }
                            */}

                            {/* {formData.receiptType !== 'delivery_note' &&
                              <div className={"p-col"}>
                                <Field name="isUnitPriceGr" render={({input, meta}) => (
                                  <div className="p-field p-fluid">
                                    <label htmlFor="itemFormData.isUnitPriceGr"
                                           className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'isUnitPriceGr')})}>{props.t('fieldItemFormDataIsUnitPriceGr')}</label>
                                    <span className="p-d-block">
                                      <InputSwitch {...input}
                                                   value={itemFormData.isUnitPriceGr}
                                                   checked={itemFormData.isUnitPriceGr}
                                                   onChange={(e) => {
                                                     setItemFormData({
                                                       ...itemFormData,
                                                       isUnitPriceGr: e.value
                                                     })
                                                     localStorage.setItem("defaultIsUnitPriceBr", e.value)
                                                   }}
                                                   className={"p-mt-1"}
                                      />
                                    </span>
                                    {getFormErrorMessage(meta, submitFailed, 'isUnitPriceGr')}
                                  </div>
                                )}/>
                              </div>
                            }
                            */}

                            {/*
                            {window.App.state.props && (window.App.state.props.receiptType === 'invoice'
                                || window.App.state.props.receiptType === 'fee_request') &&
                              <div className={"p-col"}>
                              </div>
                            }
                            */}
                          </div>
                          <div className={"p-grid p-mt-0"}>
                             <div className={"p-col-12"}>
                              <Field name="note" render={({input, meta}) => (
                                <div className="p-field p-fluid">
                                  <label htmlFor="note"
                                           className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'note')})}>{props.t('fieldItemNote')}</label>
                                  <span className={"p-d-block"}>
                                    <InputText id="note" {...input}
                                               className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'note')})}/>
                                  </span>
                                  {getFormErrorMessage(meta, submitFailed, 'note')}
                                </div>
                              )}/>
                            </div>
                          </div>

                          <div className={"p-grid"}>
                            {window.App.state.props.external === true &&
                              <>
                                {/*
                                <div className={"p-col"}>
                                  <Field name="costType" render={({input, meta}) => (
                                    <div className="p-field p-fluid">
                                      <label htmlFor="costType"
                                             className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'costType')})}>{props.t('fieldCostAllocationCosttype')}</label>
                                      <span className={"p-d-block"}>
                                        <AutoComplete value={selectedItemCosttype}
                                                      id={"costType"}
                                                      suggestions={costtypes}
                                                      forceSelection
                                                      completeMethod={searchItemCosttype}
                                                      field={"name"}
                                                      delay="1000"
                                                      placeholder={t('typeToSearchPlaceholder')}
                                                      className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'costType')})}
                                                      onSelect={(e) => {
                                                        setItemFormData({
                                                          ...itemFormData,
                                                          costType: {id: e.value.id}
                                                        })
                                                        setSelectedItemCosttype(e.value.name)
                                                      }}
                                                      onChange={(e) => {
                                                        setItemFormData({
                                                          ...itemFormData,
                                                          costType: {id: null}
                                                        })
                                                        setSelectedItemCosttype(e.value)
                                                      }}
                                                      dropdown
                                                      onClear={(e) => {
                                                        setSelectedItemCosttype('')
                                                      }}
                                        />
                                      </span>
                                      {getFormErrorMessage(meta, submitFailed, 'costType')}
                                    </div>
                                  )}/>
                                </div>
                                */}
                                {/*
                                <div className={"p-col"}>
                                  <Field name="project" render={({input, meta}) => (
                                    <div className="p-field p-fluid">
                                      <label htmlFor="project"
                                             className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'project')})}>{t('project')}</label>
                                      <span className={"p-d-block"}>
                                        <AutoComplete value={selectedItemProject}
                                                      id={"project"}
                                                      forceSelection
                                                      suggestions={projects}
                                                      completeMethod={searchItemProject}
                                                      field={"name"}
                                                      delay="1000"
                                                      dropdown
                                                      placeholder={t('typeToSearchPlaceholder')}
                                                      className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'project')})}
                                                      onSelect={(e) => {
                                                        setItemFormData({
                                                          ...itemFormData,
                                                          project: {id: e.value.id}
                                                        })
                                                      }}
                                        />
                                      </span>
                                      {getFormErrorMessage(meta, submitFailed, 'project')}
                                    </div>
                                  )}/>
                                </div>
                                */}
                                {/*
                                {localStorage.getItem('roles').toString().includes('role_technology_read') &&
                                  <div className={"p-col"}>
                                    <Field name="technology" render={({input, meta}) => (
                                      <div className="p-field p-fluid">
                                        <label htmlFor="technology"
                                               className={classNames({'p-error': isFormFieldValid(meta, submitFailed, 'technology')})}>{props.t('fieldTechnology')}</label>
                                        <span className={"p-d-block"}>
                                          <AutoComplete value={selectedItemTechnology}
                                                        id={"technology"}
                                                        suggestions={technologies}
                                                        completeMethod={searchItemTechnology}
                                                        forceSelection
                                                        field={"name"}
                                                        delay="1000"
                                                        dropdown
                                                        placeholder={t('typeToSearchPlaceholder')}
                                                        className={classNames({'p-invalid': isFormFieldValid(meta, submitFailed, 'technology')})}
                                                        onSelect={(e) => {
                                                          setItemFormData({
                                                            ...itemFormData,
                                                            technology: {id: e.value.id}
                                                          })
                                                          setSelectedItemTechnology(e.value.name)
                                                        }}
                                                        onChange={(e) => {
                                                          setItemFormData({
                                                            ...itemFormData,
                                                            technology: {id: null}
                                                          })
                                                          setSelectedItemTechnology(e.value)
                                                        }}
                                                        onClear={(e) => {
                                                          setSelectedItemTechnology('')
                                                        }}
                                          />
                                        </span>
                                        {getFormErrorMessage(meta, submitFailed, 'technology')}
                                      </div>
                                    )}/>
                                  </div>
                                }
                                */}
                              </>
                            }
                          </div>
                          <div className={"p-grid p-mt-4"}>
                            <div className={"p-col-12 p-text-right"}>
                                <Button type="submit" 
                                        label={itemFormMethod === 'create' ? t('addItems') : t('updateItems')} 
                                        loading={loading} 
                                        icon={"pi pi-check"}
                                        style={{ backgroundColor: '#8e44ad', borderColor: '#8e44ad' }}
                                        className="p-button-success" 
                                />
                            </div>
                          </div>

                        </form>
                      )}/>
              </Dialog>
            </form>
          )}/>
        </>
      )}
    </>
  )
}
const AuthorizedReceiptForm = (props) => (
  <ReceiptWriteAccess><ReceiptFormComponent {...props} /></ReceiptWriteAccess>
);

export default withTranslation('common')(AuthorizedReceiptForm);
